(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 5382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isDesktop = exports.getCommonEventProperties = void 0;
exports.waitForAnalyticsLoad = waitForAnalyticsLoad;
exports.initAckoAnalytics = initAckoAnalytics;
exports.pageEvent = pageEvent;
exports.trackEvent = trackEvent;
exports.identifyEvent = identifyEvent;
const js_cookie_1 = __importDefault(__webpack_require__(646));
const utils_1 = __webpack_require__(2684);
let write_key = '';
let anonymousId = '';
let requestURL = '/external/api/v2/send';
let dataLayerEventsList = [];
const getCommonEventProperties = (pageType = '') => {
    var _a, _b;
    let props = { page_type: pageType };
    if (typeof window != 'undefined') {
        const queryParams = new URLSearchParams(`?${(_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) === null || _b === void 0 ? void 0 : _b.split('?')[1]}`);
        props['page'] = window.location.href;
        props['path'] = window.location.pathname;
        props['source'] = document.referrer || '';
        props['referrer'] = document.referrer || '';
        props['platform'] = (0, exports.isDesktop)()
            ? 'web'
            : js_cookie_1.default.get('webview')
                ? 'app'
                : 'mweb';
        props['utm_source'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_source')) || '';
        props['utm_campaign'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_campaign')) || '';
        props['utm_content'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_content')) || '';
        props['utm_medium'] = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.get('utm_medium')) || '';
        props['url'] = window.location.href;
        props['title'] = document.title;
        props['search'] = window.location.search;
    }
    return props;
};
exports.getCommonEventProperties = getCommonEventProperties;
const isDesktop = () => {
    var _a;
    const res = typeof window !== 'undefined'
        ? (_a = window.matchMedia('(min-width: 1024px)')) === null || _a === void 0 ? void 0 : _a.matches
        : false;
    return res;
};
exports.isDesktop = isDesktop;
function waitForAnalyticsLoad() {
    return new Promise((resolve) => {
        resolve(void 0);
    });
}
function initAckoAnalytics(id, apiKey, cdpApiEndPoint = '/external/api/v2/send') {
    write_key = apiKey;
    anonymousId = id;
    requestURL = cdpApiEndPoint;
    return `window.acko_analytics={
    write_key:"${write_key}",
    anonymousId:"${anonymousId}"
  }`;
}
function pageEvent(eventName, properties, custom_write_key = null) {
    var _a, _b;
    const commonProps = (0, exports.getCommonEventProperties)();
    if (dataLayerEventsList.length === 0) {
        fetch('https://acko-cms.ackoassets.com/data_layer_events_list_seo_a0629b56ba.json')
            .then(response => response.json())
            .then(data => {
            dataLayerEventsList = data === null || data === void 0 ? void 0 : data.dataLayerEvents;
            (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
        })
            .catch(error => {
            console.error('Error fetching dataLayer events list:', error);
        });
    }
    else {
        (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
    }
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'page',
            event_name: eventName,
            event_properties: Object.assign(Object.assign({}, commonProps), properties),
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
function trackEvent(eventName, properties, custom_write_key = null) {
    var _a, _b;
    const commonProps = (0, exports.getCommonEventProperties)();
    if (dataLayerEventsList.length === 0) {
        fetch('https://acko-cms.ackoassets.com/data_layer_events_list_seo_a0629b56ba.json')
            .then(response => response.json())
            .then(data => {
            dataLayerEventsList = data === null || data === void 0 ? void 0 : data.dataLayerEvents;
            (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
        })
            .catch(error => {
            console.error('Error fetching dataLayer events list:', error);
        });
    }
    else {
        (0, utils_1.pushEventsToDataLayer)(dataLayerEventsList, eventName, commonProps, properties);
    }
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'track',
            event_name: eventName,
            event_properties: Object.assign(Object.assign({}, commonProps), properties),
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
function identifyEvent(properties, custom_write_key = null) {
    var _a, _b;
    return fetch(requestURL, {
        headers: {
            //@ts-ignore
            'x-write-key': custom_write_key
                ? custom_write_key
                : write_key || ((_a = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _a === void 0 ? void 0 : _a.write_key),
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
            event_type: 'identify',
            event_properties: properties,
            //@ts-ignore
            anonymous_id: anonymousId || ((_b = window === null || window === void 0 ? void 0 : window.acko_analytics) === null || _b === void 0 ? void 0 : _b.anonymousId),
        }),
        credentials: 'include',
    })
        .then((res) => {
        return res.json();
    })
        .then((data) => {
        console.log(data);
    })
        .catch((err) => {
        console.error('There was a problem with the CDP API fetch operation:', err);
    });
}
//# sourceMappingURL=acko-analytics.js.map

/***/ }),

/***/ 4262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(5382), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pushEventsToDataLayer = void 0;
const pushEventsToDataLayer = (dataLayerEventsList, eventName, commonProps, properties) => {
    dataLayerEventsList =
        dataLayerEventsList.length === 0
            ? [
                'tap_btn_newbike_get_quote',
                'tap_btn_newcar_get_quote',
                'tap_btn_get_quote',
                'view_seo_page',
                'tap_btn_CTA_widget',
                'phone_number_entered',
                'otp_entered',
                'tap_btn_acko_app',
                'view_page',
            ]
            : dataLayerEventsList;
    if (dataLayerEventsList.includes(eventName)) {
        // @ts-ignore
        if (window && (window === null || window === void 0 ? void 0 : window.dataLayer) !== undefined) {
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.dataLayer = (window === null || window === void 0 ? void 0 : window.dataLayer) || [];
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.dataLayer.push(Object.assign(Object.assign({ event: eventName }, commonProps), properties));
        }
    }
};
exports.pushEventsToDataLayer = pushEventsToDataLayer;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 1965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
// TODO: Refac codewise + design
const react_1 = __importDefault(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  min-height: 26px;
`;
const BounceAnimation = (0, building_blocks_ui_common_1.keyframes) `
  0% { margin-bottom: 0; }
  50% { margin-bottom: 15px }
  100% { margin-bottom: 0 }
`;
const Dot = building_blocks_ui_common_1.styled.div `
  background-color: #fff;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  /* Animation */
  animation: ${BounceAnimation} 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s
    infinite both;
  /* animation: ${BounceAnimation} 0.5s linear infinite; */
  animation-delay: ${(props) => props.delay};
`;
const LoadingDots = () => {
    return (react_1.default.createElement(Container, { alignItems: "flex-end", justifyContent: "center" },
        react_1.default.createElement(Dot, { delay: "0s" }),
        react_1.default.createElement(Dot, { delay: ".1s" }),
        react_1.default.createElement(Dot, { delay: ".2s" })));
};
exports["default"] = LoadingDots;
//# sourceMappingURL=button-loader.js.map

/***/ }),

/***/ 6806:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DarkButton = exports.TertiaryButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
const react_1 = __importDefault(__webpack_require__(1720));
const building_blocks_ui_theme_1 = __webpack_require__(549);
const styles_1 = __webpack_require__(5714);
const button_loader_1 = __importDefault(__webpack_require__(1965));
function Button({ children, 
// size controls the line height and font-size of the children inside the button
size, disabled, loading, onClick, styledButton, isTransparent, isFullWidth, }) {
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    const StyledButton = styledButton ||
        function () {
            return null;
        };
    return (react_1.default.createElement(StyledButton, { disabled: disabled, theme: theme, colors: colors, className: size, onClick: onClick, isTransparent: isTransparent, isFullWidth: isFullWidth, loading: loading }, loading ? react_1.default.createElement(button_loader_1.default, null) : children));
}
const PrimaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonPrimary })));
exports.PrimaryButton = PrimaryButton;
const SecondaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonSecondary })));
exports.SecondaryButton = SecondaryButton;
const TertiaryButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonTertiary })));
exports.TertiaryButton = TertiaryButton;
const DarkButton = (props) => (react_1.default.createElement(Button, Object.assign({}, props, { styledButton: styles_1.StyledButtonDark })));
exports.DarkButton = DarkButton;
//# sourceMappingURL=button.js.map

/***/ }),

/***/ 2518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonText = exports.DarkButton = exports.TertiaryButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
var button_1 = __webpack_require__(6806);
Object.defineProperty(exports, "PrimaryButton", ({ enumerable: true, get: function () { return button_1.PrimaryButton; } }));
Object.defineProperty(exports, "SecondaryButton", ({ enumerable: true, get: function () { return button_1.SecondaryButton; } }));
Object.defineProperty(exports, "TertiaryButton", ({ enumerable: true, get: function () { return button_1.TertiaryButton; } }));
Object.defineProperty(exports, "DarkButton", ({ enumerable: true, get: function () { return button_1.DarkButton; } }));
var button_2 = __webpack_require__(6774);
Object.defineProperty(exports, "ButtonText", ({ enumerable: true, get: function () { return button_2.ButtonText; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6774:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonText = exports.StyledButton = void 0;
const building_blocks_ui_typography_1 = __webpack_require__(9829);
const styled_components_1 = __importDefault(__webpack_require__(63));
var paddingSizeEnum;
(function (paddingSizeEnum) {
    paddingSizeEnum["large"] = "11px 0px";
    paddingSizeEnum["medium"] = "7px 0px";
    paddingSizeEnum["small"] = "5px 0px";
    // 1px disperency in extra small due to animation height
    paddingSizeEnum["extra-small"] = "4px 0px";
    paddingSizeEnum["undefined"] = "11px 0px";
})(paddingSizeEnum || (paddingSizeEnum = {}));
exports.StyledButton = styled_components_1.default.button `
  cursor: pointer;
  width: 100%;
  align-items: center;
  // adding padding due to loading button size disperency
  padding: ${(props) => !props.loading ? props.theme.spacing[2] + ' ' + props.theme.spacing[4] : paddingSizeEnum[props.className]};
  border-radius: ${(props) => props.theme.border.radius.large};
  font-weight: ${(props) => props.theme.typography.fonts.weight.T4_SB};
  line-height: ${(props) => props.theme.typography.lineHeights.H3};
  font-size: ${(props) => props.theme.typography.fonts.size.P1};
  &.large {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 117px')};
    line-height: ${(props) => props.theme.typography.lineHeights.H3};
    font-size: ${(props) => props.theme.typography.fonts.size.P1};
  }
  &.medium {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T2};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    line-height: ${(props) => props.theme.typography.lineHeights.T4_SB};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
  &.extra-small {
    ${(props) => (props.isFullWidth ? '' : 'max-width: 107px')};
    /* TODO - line height 14px doesn't exist in style guides - putting 16px here */
    line-height: ${(props) => props.theme.typography.lineHeights.C1};
    font-size: ${(props) => props.theme.typography.fonts.size.T4_SB};
  }
`;
exports.ButtonText = (0, styled_components_1.default)(building_blocks_ui_typography_1.Text) `
    color: #ffffff;
    font-weight: 500;
    font-size: height: ${props => (props.fontSize ? props.fontSize : '16px')};
    line-height: 18px;
`;
//# sourceMappingURL=button.js.map

/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonDark = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
const button_1 = __webpack_require__(6774);
exports.StyledButtonDark = (0, styled_components_1.default)(button_1.StyledButton) `
  border: none;
  color: ${(props) => props.colors.primary.n0};
  background-color: ${(props) => props.colors.primary.n600};

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=dark-button.js.map

/***/ }),

/***/ 5714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonDark = exports.StyledButtonTertiary = exports.StyledButtonSecondary = exports.StyledButtonPrimary = void 0;
var primary_button_1 = __webpack_require__(2097);
Object.defineProperty(exports, "StyledButtonPrimary", ({ enumerable: true, get: function () { return primary_button_1.StyledButtonPrimary; } }));
var secondary_button_1 = __webpack_require__(4146);
Object.defineProperty(exports, "StyledButtonSecondary", ({ enumerable: true, get: function () { return secondary_button_1.StyledButtonSecondary; } }));
var tertiary_button_1 = __webpack_require__(7035);
Object.defineProperty(exports, "StyledButtonTertiary", ({ enumerable: true, get: function () { return tertiary_button_1.StyledButtonTertiary; } }));
var dark_button_1 = __webpack_require__(1692);
Object.defineProperty(exports, "StyledButtonDark", ({ enumerable: true, get: function () { return dark_button_1.StyledButtonDark; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2097:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonPrimary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
const button_1 = __webpack_require__(6774);
exports.StyledButtonPrimary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: none;
  color: ${(props) => props.colors.primary.n0};
  background-color: ${(props) => props.colors.green.g300};

  // adding hover state only in DWeb view
  @media (min-width: 768px) {
    &:hover {
      background-color: ${(props) => props.colors.green.g400};
    }
  }

  &:active {
    background-color: ${(props) => props.colors.green.g500};
  }

  &:disabled {
    pointer-events: none;
    background-color: ${(props) => props.colors.neutral.n300};
  }
`;
//# sourceMappingURL=primary-button.js.map

/***/ }),

/***/ 4146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonSecondary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
const button_1 = __webpack_require__(6774);
exports.StyledButtonSecondary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: 1px solid ${(props) => props.colors.primary.n600};
  color: ${(props) => props.colors.primary.n600};
  background-color: ${(props) => props.isTransparent ? 'transparent' : props.colors.primary.n0};

  &:hover {
    background-color: ${(props) => props.colors.neutral.n50};
  }

  &:active {
    background-color: ${(props) => props.colors.neutral.n200};
  }

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=secondary-button.js.map

/***/ }),

/***/ 7035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledButtonTertiary = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
const button_1 = __webpack_require__(6774);
exports.StyledButtonTertiary = (0, styled_components_1.default)(button_1.StyledButton) `
  border: 1px solid ${(props) => props.colors.red.r400};
  color: ${(props) => props.colors.red.r400};
  background-color: ${(props) => props.colors.primary.n0};

  &:hover {
    background-color: ${(props) => props.colors.red.r50};
  }

  &:active {
    background-color: ${(props) => props.colors.red.r100};
  }

  &:disabled {
    pointer-events: none;
    /* TODO add OPACITY */
  }
`;
//# sourceMappingURL=tertiary-button.js.map

/***/ }),

/***/ 9749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styled = void 0;
__exportStar(__webpack_require__(4694), exports);
__exportStar(__webpack_require__(9325), exports);
__exportStar(__webpack_require__(3711), exports);
var styled_components_1 = __webpack_require__(4694);
Object.defineProperty(exports, "styled", ({ enumerable: true, get: function () { return __importDefault(styled_components_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4694:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ServerStyleSheet = exports.styledComponents = exports.ThemeProvider = exports.keyframes = exports.createGlobalStyle = exports.css = void 0;
//@ts-nocheck
const styledComponents = __importStar(__webpack_require__(63));
exports.styledComponents = styledComponents;
const { default: styled, css, createGlobalStyle, keyframes, ThemeProvider, ServerStyleSheet, } = styledComponents;
exports.css = css;
exports.createGlobalStyle = createGlobalStyle;
exports.keyframes = keyframes;
exports.ThemeProvider = ThemeProvider;
exports.ServerStyleSheet = ServerStyleSheet;
const Styled = styled;
exports["default"] = Styled;
//# sourceMappingURL=styled-components.js.map

/***/ }),

/***/ 9325:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/**
<<<<<<< HEAD
* ======================
* Break Points
* ======================
*/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.$fontWeightBolder = exports.$fontWeightBold = exports.$fontWeightNormal = exports.$fontWeightLight = exports.$primaryColorsGreen = exports.$fontSize = exports.$space = exports.$blackShades = exports.$greyShades = exports.$greenShades = exports.$backgroundColor = exports.$white = exports.$grayLighter = exports.$grayLight = exports.$hyperlink = exports.$error = exports.$info = exports.$warning = exports.$neutralColors = exports.$accentColors = exports.$primaryColors = exports.$containerXsL = exports.$screenL = exports.$screenXsL = exports.$screenXs = exports.$containerXs = exports.$gutter = void 0;
exports.$gutter = 16;
exports.$containerXs = '28.125em';
exports.$screenXs = '30em';
exports.$screenXsL = '40em';
exports.$screenL = '48em';
exports.$containerXsL = '38.125em';
/**
 * ==========
 * Colors
 * ==========
 */
exports.$primaryColors = {
    lightest: '#DDD4F8',
    light: '#9174E7',
    normal: '#582CDB',
    dark: '#421EAE',
};
exports.$accentColors = {
    lightest: '#D4F7E6',
    light: '#7EE7B4',
    normal: '#44CB86',
    dark: '#1FAD69',
};
exports.$neutralColors = {
    lightest: '#DCDCE0',
    light: '#8D8E99',
    normal: '#5C5D66',
    dark: '#151619',
};
exports.$warning = '#FF9100';
exports.$info = '#697890';
exports.$error = '#FD4B44';
exports.$hyperlink = '#3C8CEA';
exports.$grayLight = '#F3F3F7';
exports.$grayLighter = '#F3F7FF';
exports.$white = '#FFFFFF';
exports.$backgroundColor = exports.$grayLight;
exports.$greenShades = {
    normal: '#37C87E',
    dark: '#00A871',
};
exports.$greyShades = {
    normal: '#C8D0DB',
};
exports.$blackShades = {
    normal: '#434F5A',
    dark: '#282E33',
};
/**
 * ==========
 * Spacing
 * ==========
 */
exports.$space = {
    xs: '0.5em',
    s: '1em',
    sm: '1.5em',
    m: '2em',
    l: '3em',
    xl: '4em',
    xxl: '6em',
};
/**
 * ==========
 * font
 * ==========
 */
exports.$fontSize = {
    xxxs: '0.625rem', // 10px
    xxs: '0.75rem', // 12px
    xs: '0.875rem', // 14px
    normal: '1rem', // 16px
    small: '1.125rem', // 18px
    medium: '1.25rem', // 20px
    large: '1.5rem', // 24px
    xl: '1.875rem', // 30px
    xxl: '2.375rem', // 38px
    xxxl: '2.875rem', // 46px
};
exports.$primaryColorsGreen = {
    disabled: '#E5E5E5',
    lightest: '#f2faf7',
    light: '#0FA457',
    normal: '#0FA457',
    dark: '#149452',
};
/**
 * ==========
 * Font weights
 * ==========
 */
exports.$fontWeightLight = 400;
exports.$fontWeightNormal = 500;
exports.$fontWeightBold = 600;
exports.$fontWeightBolder = 700;
exports["default"] = {};
//# sourceMappingURL=theme.js.map

/***/ }),

/***/ 3711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Flex = exports.Box = void 0;
const styled_components_1 = __importDefault(__webpack_require__(63));
exports.Box = styled_components_1.default.div `
  width: ${props => (props.width ? props.width : "100%")};
  ${props => props.justifyContent ? `justify-content: ${props.justifyContent}` : ""};
  ${props => (props.alignItems ? `align-items: ${props.alignItems}` : "")};
  ${props => (props.textAlign ? `text-align: ${props.textAlign}` : "")};
  ${props => (props.margin ? `margin: ${props.margin}` : "")};
  ${props => (props.padding ? `padding: ${props.padding}` : "")};
  ${props => (props.mt ? `margin-top: ${props.mt}` : "")};
  ${props => (props.mr ? `margin-right: ${props.mr}` : "")};
  ${props => (props.mb ? `margin-bottom: ${props.mb}` : "")};
  ${props => (props.ml ? `margin-left: ${props.ml}` : "")};
  ${props => (props.pt ? `padding-top: ${props.pt}` : "")};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : "")};
  ${props => (props.pl ? `padding-left: ${props.pl}` : "")};
  ${props => (props.pr ? `padding-right: ${props.pr}` : "")};
  ${props => (props.overflow ? `overflow: ${props.overflow}` : "")};
  ${props => props.styles};
`;
exports.Flex = (0, styled_components_1.default)(exports.Box) `
  display: flex;
  ${props => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ""};
  ${props => props.styles};
`;
exports["default"] = {};
//# sourceMappingURL=util.js.map

/***/ }),

/***/ 9069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(1720));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const images_1 = __webpack_require__(7018);
const CloseButtonWrapper = building_blocks_ui_common_1.styled.div `
  position: absolute;
  right: 0;
  ${(props) => (props.setTopHeight ? `top: 0px` : '')};
  ${(props) => props.styles}
  max-width: 16px;
  max-height: 16px;
  cursor: pointer;
`;
const Wrapper = building_blocks_ui_common_1.styled.div `
  display: flex;
  width: 100%;
  position: relative;
  ${(props) => props.align === 'center' && 'justify-content: center'};
  align-items: center;
`;
function ModalHeader(props) {
    const { header, closeButton, onClick, align, hideTopPadding, closeButtonStyles, headerStyles, } = props;
    return (react_1.default.createElement(Wrapper, { align: align, style: Object.assign({}, headerStyles) },
        header,
        closeButton && (react_1.default.createElement(CloseButtonWrapper, { type: "button", onClick: onClick, setTopHeight: hideTopPadding, styles: closeButtonStyles },
            react_1.default.createElement(images_1.Cross, null)))));
}
ModalHeader.defaultProps = {
    closeButton: false,
    onClick: () => null,
    header: react_1.default.createElement("div", null),
    align: '',
};
exports["default"] = (0, react_1.memo)(ModalHeader);
//# sourceMappingURL=header.js.map

/***/ }),

/***/ 7018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Cross = Cross;
const React = __importStar(__webpack_require__(1720));
function Cross(props) {
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18.47 6.59C18.7627 6.29729 18.7627 5.82271 18.47 5.53C18.1773 5.23729 17.7027 5.23729 17.41 5.53L12 10.94L6.59 5.53C6.29729 5.23729 5.82271 5.23729 5.53 5.53C5.23729 5.82271 5.23729 6.29729 5.53 6.59L10.94 12L5.53 17.41C5.23729 17.7027 5.23729 18.1773 5.53 18.47C5.82271 18.7627 6.29729 18.7627 6.59 18.47L12 13.06L17.41 18.47C17.7027 18.7627 18.1773 18.7627 18.47 18.47C18.7627 18.1773 18.7627 17.7027 18.47 17.41L13.06 12L18.47 6.59Z" fill="#36354C"/>
</svg>    
    `,
        } }));
}
//# sourceMappingURL=images.js.map

/***/ }),

/***/ 5251:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(8670), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModalDesktop = exports.ModalDesktopComponent = void 0;
const react_1 = __importStar(__webpack_require__(1720));
// import ReactDOM from "react-dom";
const header_1 = __importDefault(__webpack_require__(9069));
const styles_1 = __webpack_require__(4135);
const removeBodyStyles = () => {
    // const { top } = document.body.style;
    document.body.setAttribute('style', '');
    // commenting this as page was scrolling to top by deafult when closing modal
    // try {
    //   window.scrollTo(0, Math.abs(parseInt(top || "0", 10)));
    // } catch (err) {
    //   // eslint-disable-next-line no-console
    //   console.log("error: ", err);
    // }
};
const ModalDesktopComponent = ({ children, header, show, onHide, variant, hideTopPadding, align, hideCloseButton, height, fullScreen, padding, maxWidth, minWidth, maxHeight, minHeight, closeButtonTop, styles, closeButtonRight, closeButtonStyles, headerStyles, bodyStyles, urlhash, overlayBG, topPosition, enterDuration, exitDuration, minimumWidth, isChallanNewFlow, 
// this prop prevents closing of modal when clicked on modal background (overlay)
disableOverlayClose = false, }) => {
    const onHideHandler = (0, react_1.useCallback)(() => {
        onHide();
    }, []);
    (0, react_1.useEffect)(() => {
        // const top: number = window.pageYOffset
        if (show) {
            // document.body.setAttribute(
            //     'style',
            //     `position: fixed; top: -${top}px; left: 0; right: 0; margin-left: auto; margin-right: auto;`
            // )
        }
        else {
            removeBodyStyles();
        }
        if (typeof window !== 'undefined') {
            if (show) {
                window.location.hash = urlhash;
                window.addEventListener('popstate', onHideHandler);
            }
            else {
                window.removeEventListener('popstate', onHideHandler);
            }
        }
    }, [show]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        show && (react_1.default.createElement(styles_1.Overlay, { onClick: disableOverlayClose ? null : onHide, backgroundColor: overlayBG })),
        show && (react_1.default.createElement(styles_1.StyledFlex, { justifyContent: "center", alignItems: "center", topPosition: topPosition, minWidth: minWidth, enterDuration: enterDuration, exitDuration: exitDuration, minimumWidth: minimumWidth, show: show },
            react_1.default.createElement(styles_1.ModalWrapper, { variant: variant, height: height, hideTopPadding: hideTopPadding, fullScreen: fullScreen, padding: padding, maxWidth: maxWidth, minWidth: minWidth, maxHeight: maxHeight, minHeight: minHeight, styles: styles, isChallanNewFlow: isChallanNewFlow },
                react_1.default.createElement(header_1.default, { closeButton: !hideCloseButton, header: header, onClick: onHide, align: align, closeButtonTop: closeButtonTop, closeButtonRight: closeButtonRight, closeButtonStyles: closeButtonStyles, styles: headerStyles }),
                react_1.default.createElement(styles_1.ModalBody, { styles: bodyStyles, hideCloseButton: hideCloseButton }, children))))));
};
exports.ModalDesktopComponent = ModalDesktopComponent;
exports.ModalDesktop = (0, react_1.memo)(exports.ModalDesktopComponent);
//# sourceMappingURL=modal-desktop.js.map

/***/ }),

/***/ 778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModalMobile = void 0;
const react_1 = __importStar(__webpack_require__(1720));
// import ReactDOM from "react-dom";
const building_blocks_ui_common_1 = __webpack_require__(9749);
const header_1 = __importDefault(__webpack_require__(9069));
const duration = 300;
const slideUp = (0, building_blocks_ui_common_1.keyframes) `
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;
const slideDown = (0, building_blocks_ui_common_1.keyframes) `
  from {
    transform: translateY(0);
  }
  to {
      transform: translateY(100%);
  }
`;
const ModalWrapper = building_blocks_ui_common_1.styled.div `
  background: ${building_blocks_ui_common_1.$white};
  z-index: 20;
  border-radius: 24px 24px 0 0;
  width: 100%;
  position: fixed;
  ${(props) => props.variant === 'large' ? 'top: 6.5%' : ''};
  bottom: 0;
  left: 0;
  padding: 30px;
  ${(props) => props.isChallanNewFlow
    ? 'overflow-x: hidden; overflow-y: scroll'
    : 'overflow: scroll;'}
  box-sizing: border-box;
  ${(props) => (props.height ? `height: ${props.height}` : '')};
  ${(props) => (props.hideTopPadding ? `padding-top: 0` : '')};
  ${(props) => (props.fullScreen ? `height: 100%; border-radius: 0;` : '')}
  ${(props) => (props.padding ? `padding: ${props.padding}` : '')};
  ${(props) => (props.styles ? props.styles : '')};
  animation: ${(props) => (0, building_blocks_ui_common_1.css) `
      ${props.show ? slideUp : slideDown} ${props.show
    ? props.enterDuration || duration
    : props.exitDuration || duration}ms ease-in-out
    `};
`;
const Overlay = building_blocks_ui_common_1.styled.div `
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: ${(props) => props.zIndex || '10'};
  ${(props) => props.showBackground ? `background-color: rgba(46, 46, 51, 0.66)` : ''};
`;
const ModalBody = building_blocks_ui_common_1.styled.div `
  margin: ${(props) => (props.bodyMargin ? props.bodyMargin : '25px 0 0 0')};
  ${(props) => (props.isChallanNewFlow ? 'height: 100%;' : '')}
`;
const removeBodyStyles = () => {
    // const { top } = document.body.style;
    document.body.setAttribute('style', '');
    // commenting this as page was scrolling to top by deafult when closing modal
    // try {
    //   window.scrollTo(0, Math.abs(parseInt(top || "0", 10)));
    // } catch (err) {
    //   // eslint-disable-next-line no-console
    //   console.log("error: ", err);
    // }
};
const ModalMobileComponent = ({ children, header, show, onHide, variant, hideTopPadding, align, hideCloseButton, height, fullScreen, padding, closeButtonStyles, headerStyles, wrapperStyles, showOverlayBackground, urlhash, enterDuration, exitDuration, bodyMargin, isChallanNewFlow, 
// this prop prevents closing of modal when clicked on modal background (overlay)
disableOverlayClose = false, }) => {
    const onHideHandler = (0, react_1.useCallback)(() => {
        onHide();
    }, []);
    (0, react_1.useEffect)(() => {
        if (show) {
            // const top: number = window.pageYOffset
            // document.body.setAttribute('style', `position: fixed; top: -${top}px`)
        }
        else {
            removeBodyStyles();
        }
        if (typeof window !== 'undefined') {
            if (show) {
                window.location.hash = urlhash;
                window.addEventListener('popstate', onHideHandler);
            }
            else {
                window.removeEventListener('popstate', onHideHandler);
            }
        }
    }, [show]);
    (0, react_1.useEffect)(() => {
        return () => {
            removeBodyStyles();
            if (typeof window !== 'undefined') {
                window.removeEventListener('popstate', onHideHandler);
            }
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        show && (react_1.default.createElement(Overlay, { onClick: disableOverlayClose ? null : onHideHandler, showBackground: showOverlayBackground })),
        show && (react_1.default.createElement(ModalWrapper, { variant: variant, height: height, hideTopPadding: hideTopPadding, fullScreen: fullScreen, padding: padding, styles: wrapperStyles, enterDuration: enterDuration, exitDuration: exitDuration, isChallanNewFlow: isChallanNewFlow, show: show },
            react_1.default.createElement(header_1.default, { closeButton: !hideCloseButton, header: header, onClick: onHideHandler, align: align, hideTopPadding: hideTopPadding, closeButtonStyles: closeButtonStyles, headerStyles: headerStyles }),
            react_1.default.createElement(ModalBody, { bodyMargin: bodyMargin ? bodyMargin : null }, children)))));
};
exports.ModalMobile = (0, react_1.memo)(ModalMobileComponent);
//# sourceMappingURL=modal-mobile.js.map

/***/ }),

/***/ 8670:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Modal = exports.ModalMobile = exports.ModalDesktop = void 0;
const modal_desktop_1 = __webpack_require__(6081);
Object.defineProperty(exports, "ModalDesktop", ({ enumerable: true, get: function () { return modal_desktop_1.ModalDesktop; } }));
Object.defineProperty(exports, "Modal", ({ enumerable: true, get: function () { return modal_desktop_1.ModalDesktop; } }));
const modal_mobile_1 = __webpack_require__(778);
Object.defineProperty(exports, "ModalMobile", ({ enumerable: true, get: function () { return modal_mobile_1.ModalMobile; } }));
//# sourceMappingURL=modal.js.map

/***/ }),

/***/ 4135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ModalBody = exports.Overlay = exports.ModalWrapper = exports.StyledFlex = exports.exiDuration = exports.duration = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
exports.duration = 500;
exports.exiDuration = 300;
const fadeIn = (0, building_blocks_ui_common_1.keyframes) `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = (0, building_blocks_ui_common_1.keyframes) `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
exports.StyledFlex = building_blocks_ui_common_1.styled.div `
  display: flex;
  ${(props) => props.flexDirection ? `flex-direction: ${props.flexDirection}` : ''};
  ${(props) => props.styles};
  width: ${(props) => (props.width ? props.width : '100%')};
  ${(props) => props.justifyContent ? `justify-content: ${props.justifyContent}` : ''};
  ${(props) => (props.alignItems ? `align-items: ${props.alignItems}` : '')};
  ${(props) => (props.textAlign ? `text-align: ${props.textAlign}` : '')};
  ${(props) => (props.margin ? `margin: ${props.margin}` : '')};
  ${(props) => (props.padding ? `padding: ${props.padding}` : '')};
  ${(props) => (props.mt ? `margin-top: ${props.mt}` : '')};
  ${(props) => (props.mr ? `margin-right: ${props.mr}` : '')};
  ${(props) => (props.mb ? `margin-bottom: ${props.mb}` : '')};
  ${(props) => (props.ml ? `margin-left: ${props.ml}` : '')};
  ${(props) => (props.pt ? `padding-top: ${props.pt}` : '')};
  ${(props) => (props.pb ? `padding-bottom: ${props.pb}` : '')};
  ${(props) => (props.pl ? `padding-left: ${props.pl}` : '')};
  ${(props) => (props.pr ? `padding-right: ${props.pr}` : '')};
  ${(props) => (props.overflow ? `overflow: ${props.overflow}` : '')};
  ${(props) => props.styles};
  position: fixed;
  z-index: 20;
  top: ${(props) => (props.topPosition ? props.topPosition : '50%')};
  left: 50%;
  padding: 30px;
  transform: translate(-50%, -50%);
  max-width: ${(props) => props.minimumWidth ? props.minimumWidth : 'fit-content'};
  animation: ${(props) => (0, building_blocks_ui_common_1.css) `
      ${props.show ? fadeIn : fadeOut} ${props.show
    ? props.enterDuration || exports.duration
    : props.exitDuration || exports.duration}ms ease-in-out
    `};
`;
exports.ModalWrapper = building_blocks_ui_common_1.styled.div `
  background: ${building_blocks_ui_common_1.$white};
  border-radius: 16px;
  width: 100%;
  ${(props) => props.variant === 'large' ? 'top: 6.5%' : ''};
  padding: 30px;
  ${(props) => props.isChallanNewFlow
    ? 'overflow-x: hidden; overflow-y: scroll'
    : 'overflow: scroll;'} box-sizing: border-box;
  ${(props) => (props.height ? `height: ${props.height}` : '')};
  ${(props) => (props.hideTopPadding ? `padding-top: 0` : '')};
  ${(props) => (props.fullScreen ? `height: 100%; border-radius: 0;` : '')}
  ${(props) => (props.padding ? `padding: ${props.padding}` : '')};
  max-width: ${(props) => props.maxWidth || '890px'};
  min-width: ${(props) => props.minWidth || ''};
  max-height: ${(props) => props.maxHeight || ''};
  min-height: ${(props) => props.minHeight || ''};
  ${(props) => props.styles}
`;
exports.Overlay = building_blocks_ui_common_1.styled.div `
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : 'rgba(46, 46, 51, 0.66)'};
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: ${(props) => props.zIndex || '10'};
`;
exports.ModalBody = building_blocks_ui_common_1.styled.div `
  margin-top: ${(props) => (props.hideCloseButton ? '0px' : '25px')};
  ${(props) => props.styles}
`;
//# sourceMappingURL=styles.js.map

/***/ }),

/***/ 6010:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTheme = exports.useColor = exports.ThemeConsumer = exports.ThemeContext = void 0;
exports["default"] = ThemeProvider;
const react_1 = __importStar(__webpack_require__(1720));
const styled_components_1 = __webpack_require__(63);
const Acko_1 = __webpack_require__(7113);
exports.ThemeContext = react_1.default.createContext({ currentMode: 'light' });
exports.ThemeConsumer = exports.ThemeContext.Consumer;
const useColor = () => {
    const { currentMode, theme } = (0, react_1.useContext)(exports.ThemeContext);
    let localTheme = theme;
    if (!localTheme) {
        localTheme = Acko_1.AckoMainTheme;
    }
    return localTheme.colors[currentMode];
};
exports.useColor = useColor;
const useTheme = () => {
    return (0, react_1.useContext)(exports.ThemeContext);
};
exports.useTheme = useTheme;
function ThemeProvider({ theme: propsTheme, mode, children }) {
    const parentThemeContext = (0, react_1.useContext)(exports.ThemeContext);
    // Todo: Replace with deepmerge
    const theme = (0, react_1.useMemo)(() => {
        if (parentThemeContext)
            return Object.assign(parentThemeContext, propsTheme);
        return propsTheme;
    }, [propsTheme, parentThemeContext]);
    if (!children) {
        return null;
    }
    const GlobalFonts = (0, styled_components_1.createGlobalStyle) `
      ${theme.typography.fonts.family.face};
  `;
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: { theme, currentMode: mode || theme.defaultMode } },
        react_1.default.createElement(GlobalFonts, null),
        children));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeProvider = exports.useTheme = exports.ThemeConsumer = exports.ThemeContext = exports.useColor = exports.AckoMainTheme = void 0;
var Acko_1 = __webpack_require__(7113);
Object.defineProperty(exports, "AckoMainTheme", ({ enumerable: true, get: function () { return Acko_1.AckoMainTheme; } }));
var ThemeProviders_1 = __webpack_require__(6010);
Object.defineProperty(exports, "useColor", ({ enumerable: true, get: function () { return ThemeProviders_1.useColor; } }));
Object.defineProperty(exports, "ThemeContext", ({ enumerable: true, get: function () { return ThemeProviders_1.ThemeContext; } }));
Object.defineProperty(exports, "ThemeConsumer", ({ enumerable: true, get: function () { return ThemeProviders_1.ThemeConsumer; } }));
Object.defineProperty(exports, "useTheme", ({ enumerable: true, get: function () { return ThemeProviders_1.useTheme; } }));
var ThemeProviders_2 = __webpack_require__(6010);
Object.defineProperty(exports, "ThemeProvider", ({ enumerable: true, get: function () { return __importDefault(ThemeProviders_2).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const border = {
    radius: {
        none: '0px',
        small: '2px',
        medium: '4px',
        large: '8px',
        xLarge: '12px',
        xxLarge: '16px',
        xxxLarge: '20px',
        max: '24px',
        xMax: '999px',
        round: '50%',
    },
    width: {
        none: '0px',
        thin: '1px',
    },
};
exports["default"] = border;
//# sourceMappingURL=border.js.map

/***/ }),

/***/ 7516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const breakpoints = {
    xs: 320,
    s: 480,
    m: 768,
    l: 1024,
    xl: 1200,
    max: 1201,
};
exports["default"] = breakpoints;
//# sourceMappingURL=breakpoints.js.map

/***/ }),

/***/ 9670:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const colors = {
    light: {
        green: {
            g50: '#EBFBEE',
            g100: '#C1F5C8',
            g200: '#8CE99A',
            g300: '#0FA457',
            g400: '#0B753E',
            g500: '#064625',
        },
        neutral: {
            n50: '#F8F7FC',
            n100: '#F0F0F6',
            n200: '#E7E7F0',
            n300: '#E0E0E8',
            n400: '#5B5675',
            n500: '#36354C',
        },
        red: {
            r50: '#FBEAEA',
            r100: '#F3C0BE',
            r200: '#F07975',
            r300: '#E05752',
            r400: '#D83D37',
            r500: '#95221D',
        },
        yellow: {
            y50: '#FFF7E5',
            y100: '#FFE380',
            y200: '#FFC400',
            y300: '#FFAB00',
            y400: '#F58700',
            y500: '#D16900',
        },
        blue: {
            b50: '#E2F5FF',
            b100: '#A9DDFE',
            b200: '#4EA3F9',
            b300: '#1B73E8',
            b400: '#104EA3',
            b500: '#0B3874',
        },
        purple: {
            p50: '#EFE9FB',
            p100: '#D0BDF4',
            p200: '#B191ED',
            p300: '#7C47E1',
            p400: '#5920C5',
            p500: '#451999',
        },
        maroon: {
            m50: '#FBE9F6',
            m100: '#FCC2D7',
            m200: '#F783AC',
            m300: '#E64980',
            m400: '#C2255C',
            m500: '#76003D',
        },
        cyan: {
            c50: '#E3FAFC',
            c100: '#B9F4F9',
            c200: '#66D9E8',
            c300: '#1DB6CD',
            c400: '#0895AA',
            c500: '#086A7D',
        },
        primary: {
            g300: '#0FA457',
            n600: '#040222',
            n0: '#FFFFFF',
        },
        secondary: {
            p300: '#7C47E1',
            cg_red: '#D83D37',
            y300: '#FFAB00',
            b300: '#1B73E8',
            m400: '#C2255C',
            c300: '#1DB6CD',
        },
    },
};
exports["default"] = colors;
//# sourceMappingURL=colors.js.map

/***/ }),

/***/ 9878:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fontWeights = exports.lineHeights = exports.fontSizes = exports.fontFamily = void 0;
exports.fontFamily = {
    family: 'Inter',
    face: `@font-face {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        src: url(https://fonts.gstatic.com/s/inter/v11/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hjp-Ek-_EeA.woff) format('woff');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }`,
};
exports.fontSizes = {
    C1: '12px',
    P2: '14px',
    P2_L: '14px',
    P1: '16px',
    T4_SB: '14px',
    T4_M: '14px',
    T3: '16px',
    T2: '18px',
    T1: '22px',
    H4: '18px',
    H3: '22px',
    H2: '26px',
    H1: '34px',
};
exports.lineHeights = {
    C1: '16px',
    P2: '20px',
    P2_L: '20px',
    P1: '22px',
    T4_SB: '20px',
    T4_M: '20px',
    T3: '22px',
    T2: '24px',
    T1: '32px',
    H4: '24px',
    H3: '32px',
    H2: '36px',
    H1: '44px',
};
exports.fontWeights = {
    P2_L: '300',
    C1: '400',
    P2: '400',
    P1: '400',
    T4_M: '500',
    T4_SB: '600',
    T3: '600',
    T2: '600',
    T1: '600',
    H4: '700',
    H3: '700',
    H2: '700',
    H1: '700',
};
//# sourceMappingURL=font.js.map

/***/ }),

/***/ 7113:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AckoMainTheme = void 0;
const border_1 = __importDefault(__webpack_require__(3288));
const typography_1 = __importDefault(__webpack_require__(4193));
const breakpoints_1 = __importDefault(__webpack_require__(7516));
const spacing_1 = __importDefault(__webpack_require__(9331));
const colors_1 = __importDefault(__webpack_require__(9670));
exports.AckoMainTheme = {
    defaultMode: 'light',
    border: border_1.default,
    breakpoints: breakpoints_1.default,
    colors: colors_1.default,
    spacing: spacing_1.default,
    typography: typography_1.default
};
exports["default"] = exports.AckoMainTheme;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9331:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const spacing = {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '32px',
    8: '40px',
    9: '48px',
    10: '56px',
};
exports["default"] = spacing;
//# sourceMappingURL=spacing.js.map

/***/ }),

/***/ 4193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const font_1 = __webpack_require__(9878);
const typography = {
    fonts: {
        family: font_1.fontFamily,
        size: font_1.fontSizes,
        weight: font_1.fontWeights
    },
    lineHeights: font_1.lineHeights
};
exports["default"] = typography;
//# sourceMappingURL=typography.js.map

/***/ }),

/***/ 3632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H5 = building_blocks_ui_common_1.styled.h5 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.medium,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
  white-space: pre-wrap;
`;
exports["default"] = H5;
//# sourceMappingURL=headingFive.js.map

/***/ }),

/***/ 7291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H4 = building_blocks_ui_common_1.styled.h4 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.large,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H4;
//# sourceMappingURL=headingFour.js.map

/***/ }),

/***/ 4489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H1 = building_blocks_ui_common_1.styled.h1 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xxxl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H1;
//# sourceMappingURL=headingOne.js.map

/***/ }),

/***/ 8539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H7 = building_blocks_ui_common_1.styled.h6 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xs,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H7;
//# sourceMappingURL=headingSeven.js.map

/***/ }),

/***/ 3169:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H6 = building_blocks_ui_common_1.styled.h6 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.normal,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H6;
//# sourceMappingURL=headingSix.js.map

/***/ }),

/***/ 9786:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H3 = building_blocks_ui_common_1.styled.h3 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H3;
//# sourceMappingURL=headingThree.js.map

/***/ }),

/***/ 6736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const H2 = building_blocks_ui_common_1.styled.h2 `
  ${(0, utils_1.getStyles)({
    fontSize: building_blocks_ui_common_1.$fontSize.xxl,
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})}
`;
exports["default"] = H2;
//# sourceMappingURL=headingTwo.js.map

/***/ }),

/***/ 8660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const H4 = building_blocks_ui_common_1.styled.h4 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H4',
    defaultFontWeight: 'H4',
    defaultLineHeight: 'H4',
})}
  `;
exports["default"] = H4;
//# sourceMappingURL=heading-four.js.map

/***/ }),

/***/ 5949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const H1 = building_blocks_ui_common_1.styled.h1 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H1',
    defaultFontWeight: 'H1',
    defaultLineHeight: 'H1'
})}
  `;
exports["default"] = H1;
//# sourceMappingURL=heading-one.js.map

/***/ }),

/***/ 730:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const H3 = building_blocks_ui_common_1.styled.h3 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H3',
    defaultFontWeight: 'H3',
    defaultLineHeight: 'H3'
})}
  `;
exports["default"] = H3;
//# sourceMappingURL=heading-three.js.map

/***/ }),

/***/ 299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const H2 = building_blocks_ui_common_1.styled.h2 `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'H2',
    defaultFontWeight: 'H2',
    defaultLineHeight: 'H2',
})}
  `;
exports["default"] = H2;
//# sourceMappingURL=heading-two.js.map

/***/ }),

/***/ 307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getStyles = void 0;
const building_blocks_ui_common_1 = __webpack_require__(9749);
const defaultStyle = "H1";
const getStyles = ({ defaultFontSize = defaultStyle, defaultFontWeight = defaultStyle, defaultLineHeight = defaultStyle, }) => props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { styles } = props || {};
    const _r = styles || {}, { fontWeight, color, fontSize, lineHeight } = _r, restStyles = __rest(_r, ["fontWeight", "color", "fontSize", "lineHeight"]);
    return (0, building_blocks_ui_common_1.css) `
    font-weight: ${fontWeight || ((_d = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.typography) === null || _b === void 0 ? void 0 : _b.fonts) === null || _c === void 0 ? void 0 : _c.weight) === null || _d === void 0 ? void 0 : _d[defaultFontWeight])};
    color: ${color || ((_h = (_g = (_f = (_e = props === null || props === void 0 ? void 0 : props.theme) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.light) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.n600)};
    font-size: ${fontSize || ((_m = (_l = (_k = (_j = props === null || props === void 0 ? void 0 : props.theme) === null || _j === void 0 ? void 0 : _j.typography) === null || _k === void 0 ? void 0 : _k.fonts) === null || _l === void 0 ? void 0 : _l.size) === null || _m === void 0 ? void 0 : _m[defaultFontSize])};
    line-height: ${lineHeight || ((_q = (_p = (_o = props === null || props === void 0 ? void 0 : props.theme) === null || _o === void 0 ? void 0 : _o.typography) === null || _p === void 0 ? void 0 : _p.lineHeights) === null || _q === void 0 ? void 0 : _q[defaultLineHeight])};
    ${(props === null || props === void 0 ? void 0 : props.center) && "text-align: center"};
    ${Object.assign({}, restStyles)}
  `;
};
exports.getStyles = getStyles;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.C1 = exports.P2_L = exports.P2 = exports.P1 = exports.T4_SB = exports.T4_M = exports.T3 = exports.T2 = exports.T1 = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Price = exports.Text = exports.SubHeading = exports.H7 = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
const headingOne_1 = __importDefault(__webpack_require__(4489));
exports.H1 = headingOne_1.default;
const headingTwo_1 = __importDefault(__webpack_require__(6736));
exports.H2 = headingTwo_1.default;
const headingThree_1 = __importDefault(__webpack_require__(9786));
exports.H3 = headingThree_1.default;
const headingFour_1 = __importDefault(__webpack_require__(7291));
exports.H4 = headingFour_1.default;
const headingFive_1 = __importDefault(__webpack_require__(3632));
exports.H5 = headingFive_1.default;
const headingSix_1 = __importDefault(__webpack_require__(3169));
exports.H6 = headingSix_1.default;
const headingSeven_1 = __importDefault(__webpack_require__(8539));
exports.H7 = headingSeven_1.default;
const subHeading_1 = __importDefault(__webpack_require__(9852));
exports.SubHeading = subHeading_1.default;
const text_1 = __importDefault(__webpack_require__(8973));
exports.Text = text_1.default;
const priceText_1 = __importDefault(__webpack_require__(273));
exports.Price = priceText_1.default;
// Headings
const heading_one_1 = __importDefault(__webpack_require__(5949));
exports.Heading1 = heading_one_1.default;
const heading_two_1 = __importDefault(__webpack_require__(299));
exports.Heading2 = heading_two_1.default;
const heading_three_1 = __importDefault(__webpack_require__(730));
exports.Heading3 = heading_three_1.default;
const heading_four_1 = __importDefault(__webpack_require__(8660));
exports.Heading4 = heading_four_1.default;
// Title 
const title_one_1 = __importDefault(__webpack_require__(2905));
exports.T1 = title_one_1.default;
const title_two_1 = __importDefault(__webpack_require__(4103));
exports.T2 = title_two_1.default;
const title_three_1 = __importDefault(__webpack_require__(7057));
exports.T3 = title_three_1.default;
const title_four_1 = __importDefault(__webpack_require__(7988));
exports.T4_M = title_four_1.default;
const title_four_semi_bold_1 = __importDefault(__webpack_require__(875));
exports.T4_SB = title_four_semi_bold_1.default;
// Paragraph And Caption
const para_one_1 = __importDefault(__webpack_require__(7584));
exports.P1 = para_one_1.default;
const para_two_1 = __importDefault(__webpack_require__(7382));
exports.P2 = para_two_1.default;
const para_two_light_1 = __importDefault(__webpack_require__(6718));
exports.P2_L = para_two_light_1.default;
const caption_one_1 = __importDefault(__webpack_require__(4849));
exports.C1 = caption_one_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const C1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'C1',
    defaultFontWeight: 'C1',
    defaultLineHeight: 'C1'
})}
  `;
exports["default"] = C1;
//# sourceMappingURL=caption-one.js.map

/***/ }),

/***/ 7584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const P1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P1',
    defaultFontWeight: 'P1',
    defaultLineHeight: 'P1'
})}
  `;
exports["default"] = P1;
//# sourceMappingURL=para-one.js.map

/***/ }),

/***/ 6718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const P2_L = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P2_L',
    defaultFontWeight: 'P2_L',
    defaultLineHeight: 'P2_L'
})}
  `;
exports["default"] = P2_L;
//# sourceMappingURL=para-two-light.js.map

/***/ }),

/***/ 7382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const P2 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'P2',
    defaultFontWeight: 'P2',
    defaultLineHeight: 'P2'
})}
  `;
exports["default"] = P2;
//# sourceMappingURL=para-two.js.map

/***/ }),

/***/ 273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const Price = building_blocks_ui_common_1.styled.span `
  text-decoration: ${props => (props.strikeThrough ? "line-through" : "")};
  font-weight: ${props => (props.strikeThrough ? "" : building_blocks_ui_common_1.$fontWeightNormal)};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  margin-right: 0.5em;
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
  &:before {
    content: "\\20B9";
  }
`;
exports["default"] = Price;
//# sourceMappingURL=priceText.js.map

/***/ }),

/***/ 9852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const SubHeading = building_blocks_ui_common_1.styled.p `
  ${(0, utils_1.getStyles)({
    fontWeight: building_blocks_ui_common_1.$fontWeightBold,
    color: building_blocks_ui_common_1.$neutralColors.dark
})};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
`;
exports["default"] = SubHeading;
//# sourceMappingURL=subHeading.js.map

/***/ }),

/***/ 8973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(6014);
const Text = building_blocks_ui_common_1.styled.p `
  ${(0, utils_1.getStyles)({
    fontWeight: building_blocks_ui_common_1.$fontWeightNormal,
    color: building_blocks_ui_common_1.$neutralColors.dark
})};
  font-size: ${props => (0, utils_1.getFontSize)(props.size)};
  ${props => props &&
    props.colorVariant &&
    `color: ${(0, utils_1.getFontColorVariant)(props.colorVariant)}`};
  ${props => props && props.fontWeight && `font-weight: ${props.fontWeight}`};
  ${props => props.styles}
`;
exports["default"] = Text;
//# sourceMappingURL=text.js.map

/***/ }),

/***/ 875:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const T4_SB = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T4_SB',
    defaultFontWeight: 'T4_SB',
    defaultLineHeight: 'T4_SB'
})}
  `;
exports["default"] = T4_SB;
//# sourceMappingURL=title-four-semi-bold.js.map

/***/ }),

/***/ 7988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const T4_M = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T4_M',
    defaultFontWeight: 'T4_M',
    defaultLineHeight: 'T4_M'
})}
  `;
exports["default"] = T4_M;
//# sourceMappingURL=title-four.js.map

/***/ }),

/***/ 2905:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const T1 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T1',
    defaultFontWeight: 'T1',
    defaultLineHeight: 'T1',
})}
  `;
exports["default"] = T1;
//# sourceMappingURL=title-one.js.map

/***/ }),

/***/ 7057:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const T3 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T3',
    defaultFontWeight: 'T3',
    defaultLineHeight: 'T3'
})}
  `;
exports["default"] = T3;
//# sourceMappingURL=title-three.js.map

/***/ }),

/***/ 4103:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const building_blocks_ui_common_1 = __webpack_require__(9749);
const utils_1 = __webpack_require__(307);
const T2 = building_blocks_ui_common_1.styled.p `
    ${(0, utils_1.getStyles)({
    defaultFontSize: 'T2',
    defaultFontWeight: 'T2',
    defaultLineHeight: 'T2'
})}
  `;
exports["default"] = T2;
//# sourceMappingURL=title-two.js.map

/***/ }),

/***/ 6014:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getStyles = void 0;
exports.getFontSize = getFontSize;
exports.getFontColorVariant = getFontColorVariant;
const building_blocks_ui_common_1 = __webpack_require__(9749);
function getFontSize(size) {
    return building_blocks_ui_common_1.$fontSize[size || "normal"];
}
function getFontColorVariant(colorVariant) {
    let fontColor;
    switch (colorVariant) {
        case "primary":
            fontColor = building_blocks_ui_common_1.$primaryColors.normal;
            break;
        case "accent":
            fontColor = building_blocks_ui_common_1.$accentColors.normal;
            break;
        case "neutral":
            fontColor = building_blocks_ui_common_1.$neutralColors.normal;
            break;
        case "error":
            fontColor = building_blocks_ui_common_1.$error;
            break;
        case "hyperlink":
            fontColor = building_blocks_ui_common_1.$hyperlink;
            break;
        case "white":
            fontColor = building_blocks_ui_common_1.$white;
            break;
        case "light":
            fontColor = building_blocks_ui_common_1.$neutralColors.light;
            break;
        default:
            fontColor = building_blocks_ui_common_1.$neutralColors.dark;
    }
    return fontColor;
}
const getStyles = ({ fontSize, fontWeight, color }) => props => {
    return (0, building_blocks_ui_common_1.css) `
    font-weight: ${fontWeight};
    color: ${props && props.color ? props.color : color};
    margin: 0;
    ${fontSize && `font-size: ${fontSize}`};
    ${props && props.center && "text-align: center"};
  `;
};
exports.getStyles = getStyles;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(6834);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var createError = __webpack_require__(5061);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(5263);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 5263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 4972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(5263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 6502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(6834);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 5061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 3572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5655);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 7185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ 6026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(5061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var enhanceError = __webpack_require__(481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 1849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 6834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 4109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 4875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(8593);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 646:
/***/ (function(module) {

/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));


/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6029)


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(9965);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ mapFormConfigs; }
/* harmony export */ });
var mapFormConfigs = function(formConfigs) {
    var newFormConfigsMap = {};
    formConfigs.forEach(function(form) {
        var should_capture_details = form.should_capture_details, details_update_required = form.details_update_required, captured_data = form.captured_data, ui_config = form.ui_config, form_type = form.form_type;
        newFormConfigsMap[form_type] = {
            uiConfig: ui_config,
            should_capture_details: should_capture_details,
            details_update_required: details_update_required,
            captured_data: captured_data
        };
    });
    return newFormConfigsMap;
};


/***/ }),

/***/ 5327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I_": function() { return /* binding */ DeviceCategory; },
/* harmony export */   "W6": function() { return /* binding */ NewPlanStages; },
/* harmony export */   "c8": function() { return /* binding */ policyDetailsInitState; }
/* harmony export */ });
/* unused harmony export popularModels */
var NewPlanStages;
(function(NewPlanStages) {
    NewPlanStages["MODEL"] = "model";
    NewPlanStages["PLAN"] = "plan";
    NewPlanStages["CUSTOMER_DEVICE_DETAILS"] = "customer_device_details";
    NewPlanStages["IMEI"] = "imei";
    NewPlanStages["DOCUMENT_UPLOAD"] = "document_upload";
    NewPlanStages["CUSTOMER_LINK"] = "customer_link";
    NewPlanStages["CONGRATULATION"] = "congratulation";
    NewPlanStages["LEGAL_DOCUMENTS_UPLOAD"] = "legal_documents_upload";
    NewPlanStages["SUMMARY"] = "summary";
    NewPlanStages["DEALER_DETAILS"] = "dealer_details";
    NewPlanStages["WALLET_PAYMENT"] = "wallet_payment";
})(NewPlanStages || (NewPlanStages = {}));
var popularModels = [
    {
        id: "find_x2",
        name: "Find X2",
        image: "/assets/findx2.svg"
    },
    {
        id: "regno7_pro_5g",
        name: "Regno7 Pro 5G",
        image: "/assets/findx2.svg"
    },
    {
        id: "regno6_pro_5g",
        name: "Regno6 Pro 5G",
        image: "/assets/findx2.svg"
    },
    {
        id: "f21_pro_5g",
        name: "F21 Pro 5G",
        image: "/assets/findx2.svg"
    }, 
];
var DeviceCategory;
(function(DeviceCategory) {
    DeviceCategory["MOBILE"] = "mobile";
    DeviceCategory["TABLET"] = "tablet";
})(DeviceCategory || (DeviceCategory = {}));
var policyDetailsInitState = {
    customer: {
        name: "",
        phone: "",
        email: "",
        pincode: ""
    },
    device: {
        id: "",
        name: "",
        type: DeviceCategory.MOBILE,
        serial_number: "",
        purchase_date: "",
        delivery_date: "",
        price: null,
        model_mapping_name: "",
        is_device_verified: false,
        activation_date: "",
        is_device_verified_in_model_page: false
    },
    document_urls: {},
    document_names: {},
    plan: {
        partner: "",
        plan_id: "",
        plan_name: "",
        purchase_date: "",
        program_id: "",
        premium: null,
        promo_name: "",
        plan_category: ""
    },
    policy_communication: false,
    order_communication: false,
    order_ekey: ""
};


/***/ }),

/***/ 9994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/newPlan/constants.ts
var constants = __webpack_require__(5327);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./utils/segment/constants.ts
var segment_constants = __webpack_require__(7316);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./components/newPlan/plans/header/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n    margin-left: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 6;\n    align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 2;\n    align-items: center;\n    justify-content: flex-end;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1c73e8;\n    cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% + 40px);\n    height: 0px;\n    border: 1px solid #e7e7f0;\n    margin-top: 10px;\n    transform: translateX(-20px);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var HeaderWrapper = dist.styled.div(_templateObject());
var PhoneIconFlex = dist.styled.div(_templateObject1());
var ModelNameFlex = dist.styled.div(_templateObject2());
var ModelName = dist.styled.div(_templateObject3());
var EditFlex = dist.styled.div(_templateObject4());
var Edit = dist.styled.div(_templateObject5());
var Hr = dist.styled.div(_templateObject6());

// EXTERNAL MODULE: ./utils/segment/index.ts
var segment = __webpack_require__(2199);
// EXTERNAL MODULE: ./hooks/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9047);
;// CONCATENATED MODULE: ./components/newPlan/plans/header/index.tsx











function PlansHeader() {
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), planDetails = ref.planDetails, setActiveStage = ref.setActiveStage, setPlanDetails = ref.setPlanDetails, userDetails = ref.userDetails;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var device = planDetails.device;
    var onEdit = function() {
        setActiveStage(constants/* NewPlanStages.MODEL */.W6.MODEL);
        setPlanDetails((0,_object_spread/* default */.Z)({}, constants/* policyDetailsInitState */.c8));
        (0,segment/* default */.Z)(segment_constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            action_type: segment_constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            action_name: segment_constants/* SegmentEventActionNames.CLICK_EDIT_MODEL */.iV.CLICK_EDIT_MODEL,
            button_name: segment_constants/* SegmentEventButtonNames.CLICK_EDIT_MODEL */.A3.CLICK_EDIT_MODEL
        }, {
            userDetails: userDetails,
            isMobile: isMobile
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(HeaderWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PhoneIconFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            width: "11px",
                            height: "16px",
                            alt: "",
                            src: (0,generics/* getImageBasePath */.m4)("/icons/phone.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModelNameFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModelName, {
                            children: device.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(EditFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Edit, {
                            onClick: onEdit,
                            children: "Edit"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
        ]
    });
}
/* harmony default export */ var header = (PlansHeader);


/***/ }),

/***/ 6982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useFetchParams; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7720);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1485);
/* eslint-disable prefer-destructuring */ 



var useFetchParams = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var partnerId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_context__WEBPACK_IMPORTED_MODULE_2__/* .MPosContext */ .w).partnerId;
    var slug = router.query.slug;
    var route = "";
    var lob = partnerId === utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .Partners.HERO_VIDA */ .wV.HERO_VIDA ? "auto-lob" : "embedded";
    var partner = "";
    if (!slug) {
        return {
            route: route,
            partner: partner,
            lob: lob
        };
    }
    if (slug.length < 2) {
        route = "error";
    } else {
        route = slug[2];
        partner = slug[1];
        lob = slug[0];
    }
    return {
        route: route,
        partner: partner,
        lob: lob
    };
};


/***/ }),

/***/ 9047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useResponsiveDevice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1720);

var useResponsiveDevice = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isMobile = ref[0], setIsMobile = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleWindowSize = function handleWindowSize(e) {
            if (e.matches) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        var mediaQuery = window.matchMedia("(max-width: 780px)");
        mediaQuery.addListener(handleWindowSize);
        handleWindowSize(mediaQuery);
        return function() {
            return mediaQuery.removeListener(handleWindowSize);
        };
    }, []);
    return {
        isMobile: isMobile
    };
};


/***/ }),

/***/ 5122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useSegmentViewEvents; }
/* harmony export */ });
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4262);
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);


var useSegmentViewEvents = function(eventName, payload) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__.waitForAnalyticsLoad)().then(function() {
            return (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_0__.pageEvent)(eventName, payload);
        });
    }, []);
};


/***/ }),

/***/ 6241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ snackbar; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./library/snackbar/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 250px;\n    background-color: ",
        ";\n    color: #fff;\n    text-align: center;\n    padding: 12px;\n    position: fixed;\n    z-index: 100;\n    bottom: 30px;\n    border-radius: 8px;\n\n    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n    animation: fadein 0.5s, fadeout 0.5s 2.5s;\n\n    @-webkit-keyframes fadein {\n        from {\n            bottom: 0;\n            opacity: 0;\n        }\n        to {\n            bottom: 30px;\n            opacity: 1;\n        }\n    }\n\n    @keyframes fadein {\n        from {\n            bottom: 0;\n            opacity: 0;\n        }\n        to {\n            bottom: 30px;\n            opacity: 1;\n        }\n    }\n\n    @-webkit-keyframes fadeout {\n        from {\n            bottom: 30px;\n            opacity: 1;\n        }\n        to {\n            bottom: 0;\n            opacity: 0;\n        }\n    }\n\n    @keyframes fadeout {\n        from {\n            bottom: 30px;\n            opacity: 1;\n        }\n        to {\n            bottom: 0;\n            opacity: 0;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    padding: 2px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 16px;\n    @media screen and (min-width: 780px) {\n        width: 18px;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: normal;\n    font-size: 10px;\n    line-height: 20px;\n    letter-spacing: 0.2px;\n    color: #ffffff;\n    margin-left: 10px;\n\n    @media screen and (min-width: 780px) {\n        font-size: 14px;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SnackBarWrapper = dist.styled.div(_templateObject(), function(props) {
    return props.backgroundColor;
});
var Wrapper = dist.styled.div(_templateObject1());
var Icon = dist.styled.div(_templateObject2());
var MessageText = dist.styled.div(_templateObject3());

// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
;// CONCATENATED MODULE: ./library/snackbar/index.tsx





var SnackBar = function(param) {
    var message = param.message, type = param.type, handleSnakbarComplete = param.handleSnakbarComplete;
    var ref = (0,compat_module.useState)(false), show = ref[0], setShow = ref[1];
    (0,compat_module.useEffect)(function() {
        if (message) {
            setShow(!!message);
        }
    }, [
        message
    ]);
    (0,compat_module.useEffect)(function() {
        if (message) {
            setTimeout(function() {
                setShow(false);
                handleSnakbarComplete && handleSnakbarComplete();
            }, 3000);
        }
    }, [
        message
    ]);
    var getColor = function() {
        switch(type){
            case "success":
                return "#37C87E";
            case "failure":
                return "#343758";
            default:
                return "#37C87E";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        style: {
            width: "100%",
            display: "flex",
            justifyContent: "center"
        },
        children: show && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SnackBarWrapper, {
            backgroundColor: getColor(),
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Icon, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)(type === "success" ? "/icons/greenTick.svg" : "/icons/error.svg"),
                                width: "16px",
                                height: "16px"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MessageText, {
                        children: message
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var snackbar = (SnackBar);


/***/ }),

/***/ 8045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(9361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(3929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(1720));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(9309);
var _useIntersection = __webpack_require__(7190);
var _imageConfigContext = __webpack_require__(9977);
var _utils = __webpack_require__(3794);
var _normalizeTrailingSlash = __webpack_require__(2392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(1720);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 9965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.theme/dist/index.js
var dist = __webpack_require__(549);
;// CONCATENATED MODULE: ./node_modules/ismobilejs/esm/isMobile.js
var appleIphone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var amazonTablet = /Silk/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackBerry = /BlackBerry/i;
var otherBlackBerry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
var isAppleTabletOnIos13 = function (navigator) {
    return (typeof navigator !== 'undefined' &&
        navigator.platform === 'MacIntel' &&
        typeof navigator.maxTouchPoints === 'number' &&
        navigator.maxTouchPoints > 1 &&
        typeof MSStream === 'undefined');
};
function createMatch(userAgent) {
    return function (regex) { return regex.test(userAgent); };
}
function isMobile(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') {
        nav = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            maxTouchPoints: navigator.maxTouchPoints || 0
        };
    }
    else if (typeof param === 'string') {
        nav.userAgent = param;
    }
    else if (param && param.userAgent) {
        nav = {
            userAgent: param.userAgent,
            platform: param.platform,
            maxTouchPoints: param.maxTouchPoints || 0
        };
    }
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') {
        userAgent = tmp[0];
    }
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') {
        userAgent = tmp[0];
    }
    var match = createMatch(userAgent);
    var result = {
        apple: {
            phone: match(appleIphone) && !match(windowsPhone),
            ipod: match(appleIpod),
            tablet: !match(appleIphone) &&
                (match(appleTablet) || isAppleTabletOnIos13(nav)) &&
                !match(windowsPhone),
            universal: match(appleUniversal),
            device: (match(appleIphone) ||
                match(appleIpod) ||
                match(appleTablet) ||
                match(appleUniversal) ||
                isAppleTabletOnIos13(nav)) &&
                !match(windowsPhone)
        },
        amazon: {
            phone: match(amazonPhone),
            tablet: !match(amazonPhone) && match(amazonTablet),
            device: match(amazonPhone) || match(amazonTablet)
        },
        android: {
            phone: (!match(windowsPhone) && match(amazonPhone)) ||
                (!match(windowsPhone) && match(androidPhone)),
            tablet: !match(windowsPhone) &&
                !match(amazonPhone) &&
                !match(androidPhone) &&
                (match(amazonTablet) || match(androidTablet)),
            device: (!match(windowsPhone) &&
                (match(amazonPhone) ||
                    match(amazonTablet) ||
                    match(androidPhone) ||
                    match(androidTablet))) ||
                match(/\bokhttp\b/i)
        },
        windows: {
            phone: match(windowsPhone),
            tablet: match(windowsTablet),
            device: match(windowsPhone) || match(windowsTablet)
        },
        other: {
            blackberry: match(otherBlackBerry),
            blackberry10: match(otherBlackBerry10),
            opera: match(otherOpera),
            firefox: match(otherFirefox),
            chrome: match(otherChrome),
            device: match(otherBlackBerry) ||
                match(otherBlackBerry10) ||
                match(otherOpera) ||
                match(otherFirefox) ||
                match(otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any =
        result.apple.device ||
            result.android.device ||
            result.windows.device ||
            result.other.device;
    result.phone =
        result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet =
        result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}
//# sourceMappingURL=isMobile.js.map
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./widgets/header/index.tsx + 1 modules
var header = __webpack_require__(9015);
// EXTERNAL MODULE: ./widgets/confirmation/index.tsx + 1 modules
var confirmation = __webpack_require__(7834);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./components/hamburger/userDetailsHeader/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    flex: 4;\n    flex-direction: column;\n    margin-left: 10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 600;\n    font-size: 22px;\n    line-height: 32px;\n    color: #040222;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n    color: #5b5675;\n    margin-top: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var ProfileFlex = building_blocks_ui_common_dist.styled.div(_templateObject1());
var UserDetailsFlex = building_blocks_ui_common_dist.styled.div(_templateObject2());
var Name = building_blocks_ui_common_dist.styled.div(_templateObject3());
var Phone = building_blocks_ui_common_dist.styled.div(_templateObject4());

;// CONCATENATED MODULE: ./components/hamburger/userDetailsHeader/index.tsx






function UserDetailsHeader() {
    var userDetails = (0,compat_module.useContext)(context/* MPosContext */.w).userDetails;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ProfileFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "60px",
                    height: "60px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/images/profile.svg")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(UserDetailsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Name, {
                        children: userDetails.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Phone, {
                        children: userDetails.phone
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var userDetailsHeader = (UserDetailsHeader);

;// CONCATENATED MODULE: ./components/hamburger/options/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    align-items: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 5;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19px;\n    color: #040222;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var styles_Wrapper = building_blocks_ui_common_dist.styled.div(styles_templateObject());
var IconFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject1());
var Title = building_blocks_ui_common_dist.styled.div(styles_templateObject2());

;// CONCATENATED MODULE: ./components/hamburger/options/index.tsx




function Options(param) {
    var id = param.id, icon = param.icon, title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Wrapper, {
        onClick: function() {
            return onClick(id);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "24px",
                    height: "24px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)(icon)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(IconFlex, {
                style: {
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "12px",
                    height: "12px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)("/icons/rightArrow.svg")
                })
            })
        ]
    });
}
/* harmony default export */ var options = (Options);

// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.modal/dist/index.js
var building_blocks_ui_modal_dist = __webpack_require__(5251);
// EXTERNAL MODULE: ./utils/segment/constants.ts
var constants = __webpack_require__(7316);
// EXTERNAL MODULE: ./hooks/useSegmentView.ts
var useSegmentView = __webpack_require__(5122);
// EXTERNAL MODULE: ./hooks/useResponsiveDevice.ts
var useResponsiveDevice = __webpack_require__(9047);
// EXTERNAL MODULE: ./hooks/useFetchParams.ts
var useFetchParams = __webpack_require__(6982);
// EXTERNAL MODULE: ./utils/constants/index.ts
var utils_constants = __webpack_require__(1485);
;// CONCATENATED MODULE: ./components/hamburger/styles.ts

function hamburger_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    hamburger_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hamburger_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 50px;\n"
    ]);
    hamburger_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hamburger_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 0;\n    border: 1px solid #e7e7f0;\n    margin: 20px 0;\n"
    ]);
    hamburger_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: absolute;\n    bottom: 20px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1b73e8;\n    margin-left: 5px;\n    cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n    font-size: 16px;\n    line-height: 24px;\n    color: #53556b;\n    font-weight: 500;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var hamburger_styles_Wrapper = building_blocks_ui_common_dist.styled.div(hamburger_styles_templateObject());
var OptionWrapper = building_blocks_ui_common_dist.styled.div(hamburger_styles_templateObject1());
var Hr = building_blocks_ui_common_dist.styled.div(hamburger_styles_templateObject2());
var LogoutFlex = building_blocks_ui_common_dist.styled.div(styles_templateObject3());
var LogoutIcon = building_blocks_ui_common_dist.styled.div(styles_templateObject4());
var Logout = building_blocks_ui_common_dist.styled.div(_templateObject5());
var SwitchingText = building_blocks_ui_common_dist.styled.div(_templateObject6());

// EXTERNAL MODULE: ./utils/localStorage/partnerStorage.js
var partnerStorage = __webpack_require__(1246);
;// CONCATENATED MODULE: ./components/hamburger/constants.ts
var TRANSACTION_ID = "transaction";
var SALES_DASHBORAD = "report_dashboard";
var CONTACT_US = "contact_us";
var DETAILS = "details";

;// CONCATENATED MODULE: ./components/hamburger/helpers.ts
// constants


function getSegmentProps(id) {
    switch(id){
        case TRANSACTION_ID:
            return {
                button_name: constants/* SegmentEventButtonNames.MY_TRANSACTION */.A3.MY_TRANSACTION,
                action_name: constants/* SegmentEventActionNames.CLICK_MY_TRANSACTIONS */.iV.CLICK_MY_TRANSACTIONS
            };
        case SALES_DASHBORAD:
            return {
                button_name: constants/* SegmentEventButtonNames.REPORT_DASHBOARD */.A3.REPORT_DASHBOARD,
                action_name: constants/* SegmentEventActionNames.CLICK_REPORT_DASHBOARD */.iV.CLICK_REPORT_DASHBOARD
            };
        case CONTACT_US:
            return {
                button_name: constants/* SegmentEventButtonNames.CONTACT_US */.A3.CONTACT_US,
                action_name: constants/* SegmentEventActionNames.CLICK_CONTACT_US */.iV.CLICK_CONTACT_US
            };
        case DETAILS:
            return {
                button_name: constants/* SegmentEventButtonNames.DETAILS */.A3.DETAILS,
                action_name: constants/* SegmentEventActionNames.CLICK_DETAILS */.iV.CLICK_DETAILS
            };
        default:
            return {
                button_name: constants/* SegmentEventButtonNames.ADD_REMOVE_SUB_DEALER */.A3.ADD_REMOVE_SUB_DEALER,
                action_name: constants/* SegmentEventActionNames.CLICK_ADD_REMOVE_SUB_DEALERS */.iV.CLICK_ADD_REMOVE_SUB_DEALERS
            };
    }
}

// EXTERNAL MODULE: ./utils/segment/index.ts
var segment = __webpack_require__(2199);
;// CONCATENATED MODULE: ./components/hamburger/index.tsx






















// helpers


function Hamburger() {
    var router = (0,next_router.useRouter)();
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var isMobile = (0,useResponsiveDevice/* useResponsiveDevice */.V)().isMobile;
    var ref = (0,compat_module.useContext)(context/* MPosContext */.w), permissionsMap = ref.permissionsMap, permissions = ref.permissions, partnerId = ref.partnerId, loggedUserRole = ref.loggedUserRole, legalDetailsUploadedStatus = ref.legalDetailsUploadedStatus, userDetails = ref.userDetails, userAccessList = ref.userAccessList;
    var purchaseJourney = permissions.purchase_journey;
    var uniquePartnerIds = new Set((userAccessList || []).map(function(access) {
        return access === null || access === void 0 ? void 0 : access.partner_id;
    }).filter(Boolean));
    var hasMultiplePartners = uniquePartnerIds.size > 1;
    var setShowHamburger = (0,compat_module.useContext)(context/* MPosContext */.w).setShowHamburger;
    var ref1 = (0,compat_module.useState)(false), showLogoutModal = ref1[0], setShowLogoutModal = ref1[1];
    var ref2 = (0,compat_module.useState)(false), isSwitchingPartner = ref2[0], setIsSwitchingPartner = ref2[1];
    /**
     * view segment hook
     */ (0,useSegmentView/* useSegmentViewEvents */.n)(constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
        page_url:  true ? window.location.href : 0,
        page_type: constants/* SegmentEventPageTypes.MAIN_PAGE */.s9.MAIN_PAGE,
        view_name: constants/* SegmentEventPages.VIEW_HAMBURGER_SCREEN */.g0.VIEW_HAMBURGER_SCREEN,
        product: constants/* PRODUCT */.c5,
        sub_product_name: constants/* SUB_PRODUCT_NAME */.tM,
        platform: isMobile ? "mweb" : "web",
        referrer: document.referrer || "",
        device: navigator.userAgent || "",
        partner: partnerId
    });
    var onClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var segmentProps;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(id === "switch_partner")) return [
                            3,
                            5
                        ];
                        setIsSwitchingPartner(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        (0,partnerStorage/* setPartnerNavState */.sy)(partnerStorage/* PARTNER_NAV_STATES.SELECTING */.I0.SELECTING);
                        return [
                            4,
                            router.push("/partners")
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setShowHamburger(false);
                        setIsSwitchingPartner(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                    case 5:
                        setShowHamburger(false);
                        switch(id){
                            case "transaction":
                                router.push("/".concat(lob, "/").concat(partnerId, "/transactions"));
                                break;
                            case "contact_us":
                                router.push("/".concat(lob, "/").concat(partnerId, "/contact-us"));
                                break;
                            case "legal_tnc":
                                router.push("/".concat(lob, "/").concat(partnerId, "/legal-tnc"));
                                break;
                            case "commissions_earned":
                                router.push("/".concat(lob, "/").concat(partnerId, "/commissions-earned"));
                                break;
                            case "commissions_earned_v1":
                                router.push("/".concat(lob, "/").concat(partnerId, "/commissions-earned-v1"));
                                break;
                            case "report_dashboard":
                                router.push("/".concat(lob, "/").concat(partnerId, "/report-dashboard"));
                                break;
                            case "details":
                                router.push("/".concat(lob, "/").concat(partnerId, "/details"));
                                break;
                            case "wallet_transactions":
                                router.push("/".concat(lob, "/").concat(partnerId, "/wallet-transactions"));
                                break;
                            default:
                                router.push("/".concat(lob, "/").concat(partnerId, "/manage-dealers"));
                        }
                        segmentProps = getSegmentProps(id);
                        (0,segment/* default */.Z)(constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, segmentProps), {
                            action_type: constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN
                        }), {
                            userDetails: userDetails,
                            isMobile: isMobile
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onClick(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var logout = function(e, status) {
        e.preventDefault();
        setShowLogoutModal(false);
        if (status === "yes") {
            window.location.href = "/logout";
        }
    };
    var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
    if (isSwitchingPartner) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(hamburger_styles_Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SwitchingText, {
                children: "Switching partner..."
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(hamburger_styles_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(userDetailsHeader, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(OptionWrapper, {
                        children: [
                            hasMultiplePartners && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "switch_partner",
                                        icon: "/icons/refresh-icon.svg",
                                        title: "Switch brand",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            !permissions.permission_list.includes("access_only_auto_commercial_flow") && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "transaction",
                                        icon: "/icons/transaction.svg",
                                        title: "My transactions",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            permissionsMap[utils_constants/* Permissions.COMMISSIONS_EARNED */.Pl.COMMISSIONS_EARNED] && purchaseJourney === "v1" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "commissions_earned",
                                        icon: "/icons/commissions_light.svg",
                                        title: "Sales Report",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            permissionsMap[utils_constants/* Permissions.COMMISSIONS_EARNED_V1 */.Pl.COMMISSIONS_EARNED_V1] && purchaseJourney === "v1" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "commissions_earned_v1",
                                        icon: "/icons/commissions_light.svg",
                                        title: "Sales Report",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            permissionsMap[utils_constants/* Permissions.REPORT_DASHBOARD */.Pl.REPORT_DASHBOARD] && purchaseJourney === "v1" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "report_dashboard",
                                        icon: "/icons/commissions_light.svg",
                                        title: "Sales Dashboard",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            (permissionsMap[utils_constants/* Permissions.ADD_SUB_DEALERS */.Pl.ADD_SUB_DEALERS] || permissionsMap[utils_constants/* Permissions.REMOVE_SUB_DEALERS */.Pl.REMOVE_SUB_DEALERS]) && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "add-remove",
                                        icon: "/icons/user.svg",
                                        title: "Add/remove sub-dealer",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "contact_us",
                                        icon: "/icons/contactUs.svg",
                                        title: "Contact us",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            permissionsMap[utils_constants/* Permissions.PROFILE_DETAILS_SECTION */.Pl.PROFILE_DETAILS_SECTION] && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "details",
                                        icon: "/icons/checkClaim.svg",
                                        title: "Details",
                                        onClick: onClick
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {})
                                ]
                            }),
                            permissionsMap[utils_constants/* Permissions.WALLET_TRANSACTIONS */.Pl.WALLET_TRANSACTIONS] && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                    id: "wallet_transactions",
                                    icon: "/icons/checkClaim.svg",
                                    title: "Wallet transactions",
                                    onClick: onClick
                                })
                            }),
                            partnerId === utils_constants/* Partners.OPPO */.wV.OPPO && !legalDetailsUploadedStatus && loggedUserRole === "dealer" && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Hr, {}),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(options, {
                                        id: "legal_tnc",
                                        icon: "/icons/tnc.png",
                                        title: "Legal T&C",
                                        onClick: onClick
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LogoutFlex, {
                        onClick: function() {
                            return setShowLogoutModal(function(s) {
                                return !s;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LogoutIcon, {
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    width: "24px",
                                    height: "24px",
                                    alt: "",
                                    src: (0,generics/* getImageBasePath */.m4)("/icons/logout.svg")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Logout, {
                                children: "Logout"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
                header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {}),
                show: showLogoutModal,
                onHide: function() {
                    return setShowLogoutModal(false);
                },
                padding: "20px",
                wrapperStyles: "border-radius: 16px 16px 0px 0px;",
                showOverlayBackground: true,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(confirmation/* default */.Z, {
                    image: "/images/alert.svg",
                    text: "Are you sure you want to log out?",
                    onClick: logout
                })
            })
        ]
    });
}
/* harmony default export */ var hamburger = (Hamburger);

// EXTERNAL MODULE: ./utils/responsive/index.tsx
var responsive = __webpack_require__(1798);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./utils/globals/poliyfills.ts
/* eslint-disable func-names */ /* eslint-disable no-extend-native */ function init() {
    Promise.prototype.finally = Promise.prototype.finally || function(callback) {
        var _this = this;
        return this.then(function(value) {
            return _this.constructor.resolve(callback === null || callback === void 0 ? void 0 : callback()).then(function() {
                return value;
            });
        }, function(reason) {
            return _this.constructor.resolve(callback === null || callback === void 0 ? void 0 : callback()).then(function() {
                throw reason;
            });
        });
    };
}

;// CONCATENATED MODULE: ./utils/globals/index.ts
/* provided dependency */ var process = __webpack_require__(3454);
/* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/ban-ts-comment */ 



function initGlobals() {
    if (true) {
        init();
        window["r2d2"] = r2d2;
        window["track"] = track;
        window["cookie"] = cookie;
    }
}
function r2d2(in_) {
    var url = cookie("corp_session") ? "".concat(process.env.NEXT_PUBLIC_CORP_PLATFORM_AUTH_URL || "", "/authorization/api/r2d2/") : "/api/r2d2/";
    return axios_default().post(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        app: "NS_Container",
        ua: window === null || window === void 0 ? void 0 : window.navigator.userAgent,
        user: in_.user || cookie("user_id"),
        tracker: in_.tracker || cookie("trackerid")
    }, in_), {
        edata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, in_.edata || {}), {
            anonymousID: webengageAnonymousID(),
            ga_client_id: getGAClientID(),
            is_js: true,
            platform: window.innerWidth < 480 ? "mweb" : "web",
            web_engage: true
        }),
        odata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, in_.odata || {}), {
            url: window === null || window === void 0 ? void 0 : window.location.href
        })
    }), {
        withCredentials: true
    });
}
function track(in_) {
    // @ts-ignore
    typeof dataLayer !== "undefined" && dataLayer.push(in_);
}
function getGAClientID() {
    try {
        return window["ga"].getAll()[0].get("clientId");
    } catch (e) {
        return "";
    }
}
function webengageAnonymousID() {
    var aid = cookie("we_aid");
    if (aid !== undefined) return aid;
    try {
        var w = window;
        aid = w.webengage.user.getAnonymousId();
        cookie("we_aid", aid);
    } catch (e) {
        aid = "";
    }
    return aid;
}
function cookie(key, value) {
    if (typeof document === "undefined") return;
    if (typeof key === "string" && typeof value === "string") {
        document.cookie = "".concat(key, "=").concat(value, ";path=/");
        return value;
    }
    if (document.cookie.indexOf("".concat(key, "=")) === -1) return;
    return document.cookie.split("".concat(key, "="))[1].split(";")[0];
}

// EXTERNAL MODULE: ./widgets/errorScreen/index.tsx + 1 modules
var errorScreen = __webpack_require__(8269);
// EXTERNAL MODULE: ./library/snackbar/index.tsx + 1 modules
var library_snackbar = __webpack_require__(6241);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(906);
// EXTERNAL MODULE: ./components/newPlan/constants.ts
var newPlan_constants = __webpack_require__(5327);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var building_blocks_ui_acko_analytics_dist = __webpack_require__(4262);
// EXTERNAL MODULE: ./utils/styles/index.ts
var styles = __webpack_require__(7631);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
;// CONCATENATED MODULE: ./utils/segment/credentials.ts
/* provided dependency */ var credentials_process = __webpack_require__(3454);
var getSegmentKey = function(host) {
    try {
        if (host === null || host === void 0 ? void 0 : host.includes("localhost")) {
            return "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj";
        }
        if (credentials_process.env.NEXT_PUBLIC_ENVIRONMENT === "sandbox2" || credentials_process.env.NEXT_PUBLIC_ENVIRONMENT === "master" || credentials_process.env.NEXT_PUBLIC_ENVIRONMENT === "isnp") {
            return "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj";
        }
        return "Db7qg80zZq79SffgRblhPHcSuBwraILN";
    } catch (e) {
        return "OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj";
    }
};

;// CONCATENATED MODULE: ./utils/globals/initialiseAckoAnalytics.tsx
/* eslint-disable react/no-danger */ 




var initialiseAckoAnalytics = function() {
    var ref;
    var trackerId = js_cookie/* default.get */.Z.get("trackerid") || "";
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((head_default()), {
        children: !!trackerId ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("script", {
            async: true,
            defer: true,
            type: "text/javascript",
            dangerouslySetInnerHTML: {
                __html: (0,building_blocks_ui_acko_analytics_dist.initAckoAnalytics)(trackerId, getSegmentKey(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname))
            }
        }) : null
    });
};

// EXTERNAL MODULE: ./utils/cookie/index.ts
var utils_cookie = __webpack_require__(4164);
// EXTERNAL MODULE: ./utils/helpers/bootstrapUserPermissions.ts
var bootstrapUserPermissions = __webpack_require__(1272);
// EXTERNAL MODULE: ./utils/helpers/userAccess.ts
var userAccess = __webpack_require__(1566);
;// CONCATENATED MODULE: ./pages/_app.tsx
/* eslint-disable react/jsx-no-constructed-context-values */ 


























function MPosApp(props) {
    var Component = props.Component, pageProps = props.pageProps, isMobileDevice = props.isMobileDevice, query = props.query, host = props.host, cookie = props.cookie;
    var router = (0,next_router.useRouter)();
    var ref = (0,compat_module.useState)({
        user_id: "",
        address: "",
        email: "",
        name: "",
        partner_id: "",
        phone: "",
        pincode: ""
    }), userDetails = ref[0], setUserDetails = ref[1];
    var ref1 = (0,compat_module.useState)({
        group: "",
        partner_id: "",
        partner_logo: "",
        permission_list: [],
        role: "",
        purchase_journey: "v0"
    }), permissions = ref1[0], setPermissions = ref1[1];
    var ref2 = (0,compat_module.useState)({
        promoter_id_visibility: false
    }), metaData = ref2[0], setMetaData = ref2[1];
    var ref3 = (0,compat_module.useState)(""), dealerType = ref3[0], setDealerType = ref3[1];
    var ref4 = (0,compat_module.useState)(""), partnerId = ref4[0], setPartnerId = ref4[1];
    var ref5 = (0,compat_module.useState)({}), permissionsMap = ref5[0], setPermissionsMap = ref5[1];
    var ref6 = (0,compat_module.useState)(false), showHamburger = ref6[0], setShowHamburger = ref6[1];
    var ref7 = (0,compat_module.useState)(false), showErrorScreen = ref7[0], setShowErrorScreen = ref7[1];
    var ref8 = (0,compat_module.useState)(true), isLoading = ref8[0], setIsLoading = ref8[1];
    var ref9 = (0,compat_module.useState)({
        type: "",
        message: ""
    }), snackbar = ref9[0], setSnackbar = ref9[1];
    var ref10 = (0,compat_module.useState)(newPlan_constants/* NewPlanStages.MODEL */.W6.MODEL), stage = ref10[0], setActiveStage = ref10[1];
    var ref11 = (0,compat_module.useState)(newPlan_constants/* policyDetailsInitState */.c8), planDetails = ref11[0], setPlanDetails = ref11[1];
    var ref12 = (0,compat_module.useState)(false), legalDetailsUploadedStatus = ref12[0], setLegalDetailsUploadedStatus = ref12[1];
    var ref13 = (0,compat_module.useState)("others"), loggedUserRole = ref13[0], setLoggedUserRole = ref13[1];
    var ref14 = (0,compat_module.useState)(""), errorMessage = ref14[0], setErrorMessage = ref14[1];
    var ref15 = (0,compat_module.useState)(true), gstDetailsValid = ref15[0], setGstDetailsValid = ref15[1];
    var ref16 = (0,compat_module.useState)(true), gstDetailsSubmitAction = ref16[0], setGstDetailsSubmitAction = ref16[1];
    var ref17 = (0,compat_module.useState)({}), formConfigsMap = ref17[0], setFormConfigsMap = ref17[1];
    var ref18 = (0,compat_module.useState)([]), userAccessList = ref18[0], setUserAccessList = ref18[1];
    (0,compat_module.useEffect)(function() {
        initialiseAckoAnalytics();
    }, [
        router === null || router === void 0 ? void 0 : router.pathname
    ]);
    (0,compat_module.useEffect)(function() {
        if (userDetails.user_id) {
            /**
             * identify segment event call
             */ (0,building_blocks_ui_acko_analytics_dist.identifyEvent)(userDetails.user_id, {
                phone: userDetails.phone
            });
        }
    }, [
        userDetails
    ]);
    (0,compat_module.useEffect)(function() {
        var ref, ref1;
        if (router.pathname.includes("login") || router.pathname.includes("logout")) {
            return;
        }
        if (Array.isArray(router.query.slug) && ((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.slug) === null || ref1 === void 0 ? void 0 : ref1.length) && (userDetails === null || userDetails === void 0 ? void 0 : userDetails.partner_id)) {
            if (legalDetailsUploadedStatus && userDetails.partner_id === utils_constants/* Partners.OPPO */.wV.OPPO && loggedUserRole === "dealer") {
                router.push("/embedded/".concat(userDetails.partner_id, "/legal-documents"));
            }
        }
    }, [
        JSON.stringify(router.query.slug),
        legalDetailsUploadedStatus,
        loggedUserRole, 
    ]);
    (0,compat_module.useEffect)(function() {
        if (router.pathname.includes("/login") || router.pathname.includes("/logout") || router.pathname.includes("/partners")) {
            setIsLoading(false);
            return;
        }
        var initialiseUserAccessAndPermissions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, user_access, user_details, latestAccessList, selectedPartnerContext, selectedPartnerId, selectedGroupName, matchedPartner, matchedGroup, e, ref3, ref4, ref5;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,userAccess/* fetchUserAccess */.y)()
                            ];
                        case 1:
                            ref2 = _state.sent(), user_access = ref2.user_access, user_details = ref2.user_details;
                            latestAccessList = user_access || [];
                            (0,partnerStorage/* saveUserAccess */.Xr)(latestAccessList);
                            setUserAccessList(latestAccessList);
                            if (user_details) {
                                setUserDetails(function(prevState) {
                                    return (0,_object_spread/* default */.Z)({}, prevState, user_details);
                                });
                            }
                            selectedPartnerContext = (0,partnerStorage/* getPartnerContext */.gu)();
                            selectedPartnerId = selectedPartnerContext === null || selectedPartnerContext === void 0 ? void 0 : selectedPartnerContext.partner_id;
                            selectedGroupName = selectedPartnerContext === null || selectedPartnerContext === void 0 ? void 0 : (ref = selectedPartnerContext.group) === null || ref === void 0 ? void 0 : ref.group_name;
                            matchedPartner = latestAccessList.find(function(access) {
                                return (access === null || access === void 0 ? void 0 : access.partner_id) === selectedPartnerId;
                            });
                            matchedGroup = matchedPartner === null || matchedPartner === void 0 ? void 0 : (ref1 = matchedPartner.groups) === null || ref1 === void 0 ? void 0 : ref1.find(function(group) {
                                return (group === null || group === void 0 ? void 0 : group.group_name) === selectedGroupName;
                            });
                            if (!matchedPartner || !matchedGroup) {
                                setIsLoading(false);
                                router.push("/partners");
                                return [
                                    2
                                ];
                            }
                            (0,bootstrapUserPermissions/* bootstrapUserPermissions */.u)({
                                router: router,
                                groupName: selectedGroupName,
                                partnerId: selectedPartnerId,
                                setPermissions: setPermissions,
                                setUserDetails: setUserDetails,
                                setMetaData: setMetaData,
                                setPartnerId: setPartnerId,
                                setShowErrorScreen: setShowErrorScreen,
                                setPermissionsMap: setPermissionsMap,
                                setDealerType: setDealerType,
                                setLoggedUserRole: setLoggedUserRole,
                                setLegalDetailsUploadedStatus: setLegalDetailsUploadedStatus,
                                setActiveStage: setActiveStage,
                                setGstDetailsValid: setGstDetailsValid,
                                setGstDetailsSubmitAction: setGstDetailsSubmitAction,
                                setFormConfigsMap: setFormConfigsMap,
                                setSnackbar: setSnackbar,
                                setErrorMessage: setErrorMessage,
                                setIsLoading: setIsLoading
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            if ((e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 401) {
                                setSnackbar({
                                    type: "failure",
                                    message: "Token expired. Redirecting to login page"
                                });
                                setIsLoading(false);
                                router.push("/login");
                                return [
                                    2
                                ];
                            }
                            setErrorMessage((e === null || e === void 0 ? void 0 : (ref4 = e.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "Failed to fetch user access");
                            setShowErrorScreen(true);
                            setIsLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function initialiseUserAccessAndPermissions() {
                return _ref.apply(this, arguments);
            };
        }();
        initialiseUserAccessAndPermissions();
    }, []);
    (0,compat_module.useEffect)(function() {
        initGlobals();
        // Set tracker ID cookie if not present
        (0,utils_cookie/* setTrackerIdCookie */.lO)();
    }, []);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PageLoader */.wY, {
            src: (0,generics/* getImageBasePath */.m4)("/gif/pageLoader.gif")
        });
    }
    if (showErrorScreen) {
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(errorScreen/* default */.Z, {
            errorMessage: errorMessage
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.ThemeProvider, {
        theme: dist.AckoMainTheme,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(context/* MPosContext.Provider */.w.Provider, {
            value: {
                cookie: cookie,
                partnerId: partnerId,
                userDetails: userDetails,
                permissions: permissions,
                metaData: metaData,
                dealerType: dealerType,
                showHamburger: showHamburger,
                permissionsMap: permissionsMap,
                activeStage: stage,
                planDetails: planDetails,
                legalDetailsUploadedStatus: legalDetailsUploadedStatus,
                loggedUserRole: loggedUserRole,
                gstDetailsValid: gstDetailsValid,
                gstDetailsSubmitAction: gstDetailsSubmitAction,
                formConfigsMap: formConfigsMap,
                userAccessList: userAccessList,
                setPlanDetails: setPlanDetails,
                setUserAccessList: setUserAccessList,
                setActiveStage: setActiveStage,
                setPermissions: setPermissions,
                setUserDetails: setUserDetails,
                setPartnerId: setPartnerId,
                setShowHamburger: setShowHamburger,
                setSnackbar: setSnackbar,
                setLoggedUserRole: setLoggedUserRole,
                setLegalDetailsUploadedStatus: setLegalDetailsUploadedStatus,
                setGstDetailsValid: setGstDetailsValid,
                setMetaData: setMetaData,
                setPermissionsMap: setPermissionsMap,
                setGstDetailsSubmitAction: setGstDetailsSubmitAction,
                setFormConfigsMap: setFormConfigsMap
            },
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(responsive/* ViewportProvider */.j, {
                isMobileDevice: isMobileDevice,
                children: showHamburger ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(hamburger, {}) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                            query: query,
                            host: host,
                            cookie: cookie
                        })),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(library_snackbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snackbar), {
                            handleSnakbarComplete: function() {
                                return setSnackbar({
                                    type: "",
                                    message: ""
                                });
                            }
                        }))
                    ]
                })
            })
        })
    });
}
MPosApp.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, appProps, userAgent, isMobileDevice;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        app["default"].getInitialProps(context)
                    ];
                case 1:
                    appProps = _state.sent();
                    userAgent =  false ? 0 : window === null || window === void 0 ? void 0 : (ref2 = window.navigator) === null || ref2 === void 0 ? void 0 : ref2.userAgent;
                    isMobileDevice = isMobile(userAgent).any;
                    return [
                        2,
                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appProps), {
                            isMobileDevice: isMobileDevice,
                            query: context === null || context === void 0 ? void 0 : (ref3 = context.ctx) === null || ref3 === void 0 ? void 0 : ref3.query,
                            host: context === null || context === void 0 ? void 0 : (ref4 = context.ctx) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.req) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.headers) === null || ref6 === void 0 ? void 0 : ref6.host,
                            cookie: (context === null || context === void 0 ? void 0 : (ref7 = context.ctx) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.req) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.headers) === null || ref9 === void 0 ? void 0 : ref9.cookie) || ""
                        })
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (MPosApp);


/***/ }),

/***/ 1349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "callValidateGSTDetails": function() { return /* binding */ callValidateGSTDetails; },
  "dealerPayment": function() { return /* binding */ dealerPayment; },
  "fetchCurrentGSTDetailsOfUser": function() { return /* binding */ fetchCurrentGSTDetailsOfUser; },
  "getTrackerDetails": function() { return /* binding */ getTrackerDetails; },
  "sendR2D2Event": function() { return /* binding */ sendR2D2Event; },
  "submitGSTDetailsOfUser": function() { return /* binding */ submitGSTDetailsOfUser; },
  "uploadDocument": function() { return /* binding */ uploadDocument; },
  "validateGSTDetailsOfUser": function() { return /* binding */ validateGSTDetailsOfUser; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92);
// EXTERNAL MODULE: ./utils/cookie/index.ts
var cookie = __webpack_require__(4164);
// EXTERNAL MODULE: ./utils/serverConfig/index.ts
var serverConfig = __webpack_require__(4733);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
;// CONCATENATED MODULE: ./utils/api/url.ts

var API_ENDPOINTS = {
    gst: {
        fetchGSTDetails: function(partnerId, groupName) {
            return "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/gst-details/fetch?group_name=").concat(groupName);
        },
        submitGSTDetails: function(partnerId, groupName) {
            return "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/gst-details/submit?group_name=").concat(groupName);
        },
        validateGSTDetails: function(partnerId, groupName, async) {
            return "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/user/gst-details/validate?group_name=").concat(groupName, "&async=").concat(async.valueOf());
        }
    }
};
/* harmony default export */ var url = (API_ENDPOINTS);

;// CONCATENATED MODULE: ./utils/api/services.ts









function getTrackerDetails(policyEkey, claimRequestNumber) {
    return _getTrackerDetails.apply(this, arguments);
}
function _getTrackerDetails() {
    _getTrackerDetails = (0,_async_to_generator/* default */.Z)(function(policyEkey, claimRequestNumber) {
        var url, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0,cookie/* setIframeUserIdCookie */.yx)();
                    url = policyEkey ? "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/partnerships/fetch/tracker?policy_ekey=").concat(policyEkey) : "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/partnerships/fetch/tracker?claim_request_number=").concat(claimRequestNumber);
                    return [
                        4,
                        axios_default().get(url)
                    ];
                case 1:
                    response = _state.sent();
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        return [
                            2,
                            response.data
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _getTrackerDetails.apply(this, arguments);
}
var sendR2D2Event = function(param) {
    var ekind = param.ekind, _okind = param.okind, okind = _okind === void 0 ? "electronics_fnol" : _okind, edata = param.edata, odata = param.odata, trackerDetails = param.trackerDetails, policyDetails = param.policyDetails;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    return r2d2({
        ekind: ekind,
        edata: (0,_object_spread/* default */.Z)({
            plan: policyDetails === null || policyDetails === void 0 ? void 0 : (ref = policyDetails.plan) === null || ref === void 0 ? void 0 : ref.name,
            plan_type: policyDetails === null || policyDetails === void 0 ? void 0 : (ref1 = policyDetails.plan) === null || ref1 === void 0 ? void 0 : ref1.category,
            partner: policyDetails === null || policyDetails === void 0 ? void 0 : (ref2 = policyDetails.partner) === null || ref2 === void 0 ? void 0 : ref2.id,
            policy_number: policyDetails === null || policyDetails === void 0 ? void 0 : policyDetails.policy_number,
            product_name: policyDetails === null || policyDetails === void 0 ? void 0 : (ref3 = policyDetails.product) === null || ref3 === void 0 ? void 0 : ref3.name,
            category: policyDetails === null || policyDetails === void 0 ? void 0 : (ref4 = policyDetails.product) === null || ref4 === void 0 ? void 0 : ref4.category,
            serial_number: policyDetails === null || policyDetails === void 0 ? void 0 : (ref5 = policyDetails.product) === null || ref5 === void 0 ? void 0 : ref5.serial_number
        }, edata),
        odata: {
            user_id: js_cookie/* default.get */.Z.get("user_id") || "",
            email: policyDetails === null || policyDetails === void 0 ? void 0 : (ref6 = policyDetails.customer) === null || ref6 === void 0 ? void 0 : ref6.email,
            phone: policyDetails === null || policyDetails === void 0 ? void 0 : (ref7 = policyDetails.customer) === null || ref7 === void 0 ? void 0 : ref7.phone,
            platform: window.innerWidth < 480 ? "mweb" : "web",
            event_type: odata === null || odata === void 0 ? void 0 : odata.eventType,
            lob: odata === null || odata === void 0 ? void 0 : odata.lob,
            page_url: window.location.href,
            refer_url: policyDetails === null || policyDetails === void 0 ? void 0 : policyDetails.referrer_url,
            ip: trackerDetails === null || trackerDetails === void 0 ? void 0 : trackerDetails.ip,
            device: trackerDetails === null || trackerDetails === void 0 ? void 0 : trackerDetails.browser
        },
        okind: okind,
        oid: (ref8 = new URL(window.location.href)) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.searchParams) === null || ref9 === void 0 ? void 0 : ref9.get("policyid")
    }).catch(function() {
        return null;
    });
};
var uploadDocument = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, file, documentType, user_id, onUploadProgress) {
        var myHeaders, formData, ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    myHeaders = new Headers();
                    myHeaders.append("accept", "application/json, text/plain, */*");
                    myHeaders.append("content-type", "application/json;charset=UTF-8");
                    formData = new FormData();
                    formData.append("document", file, file.name);
                    formData.append("requestContext", "POLICY");
                    formData.append("documentType", documentType);
                    formData.append("userId", user_id);
                    return [
                        4,
                        axios_default().request({
                            method: "POST",
                            url: url,
                            data: formData,
                            headers: {
                                "Content-Type": "multipart/form-data"
                            },
                            onUploadProgress: onUploadProgress
                        })
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200) {
                        return [
                            2,
                            {
                                status: true,
                                data: data
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadDocument(url, file, documentType, user_id, onUploadProgress) {
        return _ref.apply(this, arguments);
    };
}();
var callValidateGSTDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, groupName, async) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default()((0,_object_spread/* default */.Z)({
                            method: "POST",
                            url: url.gst.validateGSTDetails(partnerId, groupName, async)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            is_error: false,
                            data: data,
                            error_message: ""
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            error_message: "",
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function callValidateGSTDetails(partnerId, groupName, async) {
        return _ref.apply(this, arguments);
    };
}();
var fetchCurrentGSTDetailsOfUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, groupName) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default()((0,_object_spread/* default */.Z)({
                            method: "GET",
                            url: url.gst.fetchGSTDetails(partnerId, groupName)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            is_error: false,
                            data: data,
                            error_message: ""
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            error_message: "",
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchCurrentGSTDetailsOfUser(partnerId, groupName) {
        return _ref.apply(this, arguments);
    };
}();
var validateGSTDetailsOfUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, groupName) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default()((0,_object_spread/* default */.Z)({
                            method: "GET",
                            url: url.gst.fetchGSTDetails(partnerId, groupName)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            is_error: false,
                            data: data,
                            error_message: ""
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            error_message: "",
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function validateGSTDetailsOfUser(partnerId, groupName) {
        return _ref.apply(this, arguments);
    };
}();
var submitGSTDetailsOfUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, groupName, request) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default()((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            method: "POST",
                            url: url.gst.submitGSTDetails(partnerId, groupName)
                        }, (0,serverConfig/* getAxiosConfig */.uZ)()), {
                            data: request
                        }))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            is_error: false,
                            data: data,
                            error_message: ""
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            is_error: true,
                            error_message: "",
                            data: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function submitGSTDetailsOfUser(partnerId, groupName, request) {
        return _ref.apply(this, arguments);
    };
}();
var dealerPayment = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(partnerId, order_ekey) {
        var ref, status, data, e, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios_default()({
                            method: "POST",
                            url: "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/api/mpos/partner/").concat(partnerId, "/payment"),
                            data: {
                                user_type: "dealer",
                                order_ekey: order_ekey
                            },
                            headers: (0,_object_spread/* default */.Z)({}, (0,serverConfig/* getHeaders */.wU)())
                        })
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200 && data) {
                        return [
                            2,
                            {
                                data: data,
                                status: true
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 2:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref1 = e.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                        return [
                            2,
                            {
                                statusCode: 401,
                                status: false
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            status: false
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function dealerPayment(partnerId, order_ekey) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ Device; },
/* harmony export */   "G4": function() { return /* binding */ AckoLogoConfig; },
/* harmony export */   "PE": function() { return /* binding */ PurchaseJourney; },
/* harmony export */   "Pl": function() { return /* binding */ Permissions; },
/* harmony export */   "RZ": function() { return /* binding */ ERROR_MESSAGES; },
/* harmony export */   "ZO": function() { return /* binding */ autoPartnershipPartners; },
/* harmony export */   "_B": function() { return /* binding */ LiquidDamage; },
/* harmony export */   "co": function() { return /* binding */ autoLobPartners; },
/* harmony export */   "dz": function() { return /* binding */ FORM_TYPES; },
/* harmony export */   "ki": function() { return /* binding */ ElectronicsFailure; },
/* harmony export */   "qI": function() { return /* binding */ ScreenDamage; },
/* harmony export */   "r6": function() { return /* binding */ LOB; },
/* harmony export */   "s7": function() { return /* binding */ AccidentalDamage; },
/* harmony export */   "wV": function() { return /* binding */ Partners; }
/* harmony export */ });
/* unused harmony export EtherPath */
var Partners;
(function(Partners) {
    Partners["OPPO"] = "oppo";
    Partners["REALME"] = "realme";
    Partners["HERO_VIDA"] = "hero_vida";
    Partners["XIAOMI"] = "Xiaomi";
})(Partners || (Partners = {}));
var LOB;
(function(LOB) {
    LOB["EMBEDDED"] = "embedded";
    LOB["AUTO"] = "auto-lob";
    LOB["AUTO_PARTNERSHIP"] = "auto-partnership";
})(LOB || (LOB = {}));
var PurchaseJourney;
(function(PurchaseJourney) {
    PurchaseJourney["V0"] = "v0";
    PurchaseJourney["V1"] = "v1";
})(PurchaseJourney || (PurchaseJourney = {}));
var Permissions;
(function(Permissions) {
    Permissions["ADD_SUB_DEALERS"] = "add_sub_dealer";
    Permissions["REMOVE_SUB_DEALERS"] = "remove_sub_dealer";
    Permissions["COMMISSIONS_EARNED"] = "commissions_earned";
    Permissions["COMMISSIONS_EARNED_V1"] = "commissions_earned_v1";
    Permissions["CUSTOMER_PDF"] = "customer_pdf";
    Permissions["GST_INVOICE"] = "gst_invoice";
    Permissions["REPORT_DASHBOARD"] = "report_dashboard";
    Permissions["PROFILE_DETAILS_SECTION"] = "profile_details_section";
    Permissions["WALLET_TRANSACTIONS"] = "wallet_passbook";
})(Permissions || (Permissions = {}));
var LiquidDamage = {
    icon: "/icons/liquidDamage.svg",
    title: "Liquid damage",
    subTitle: "Coffee spills? No problem, we'll fix that"
};
var AccidentalDamage = {
    icon: "/icons/accidentalDamage.svg",
    title: "Accidental Damage",
    subTitle: "Dropped your device? We'll fix that too!"
};
var ScreenDamage = {
    icon: "/icons/liquidDamage.svg",
    title: "Screen damage",
    subTitle: "Cracked your screen? We’ll replace it!"
};
var ElectronicsFailure = {
    icon: "/icons/electronics.svg",
    title: "Electrical & mechanical failures",
    subTitle: "Device stopped working? We’ll fix it!"
};
var EtherPath = "ether";
var autoLobPartners = [
    "ather",
    "hero_vida"
];
var autoPartnershipPartners = [
    "ackodrive"
];
var Device;
(function(Device) {
    Device["MOBILE"] = "mobile";
    Device["TABLET"] = "tablet";
    Device["APPLIANCE"] = "appliance";
})(Device || (Device = {}));
var AckoLogoConfig = {
    gradient: "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg",
    light: "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg",
    favicon: "https://acko-brand.ackoassets.com/favicon/favicon.ico"
};
var ERROR_MESSAGES = {
    VIN_VALIDATION_FAILED_MESSAGE: "Vin Validation failed"
};
var FORM_TYPES = {
    DEALER_DETAILS: "dealer_details"
};


/***/ }),

/***/ 7720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ MPosContext; }
/* harmony export */ });
/* harmony import */ var components_newPlan_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5327);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);


var MPosContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    cookie: "",
    partnerId: "",
    permissions: {
        group: "",
        partner_id: "",
        partner_logo: "",
        permission_list: [],
        role: "",
        purchase_journey: "v0"
    },
    userDetails: {
        user_id: "",
        address: "",
        email: "",
        name: "",
        partner_id: "",
        phone: "",
        pincode: ""
    },
    metaData: {
        promoter_id_visibility: false
    },
    dealerType: "",
    showHamburger: true,
    permissionsMap: {},
    activeStage: components_newPlan_constants__WEBPACK_IMPORTED_MODULE_0__/* .NewPlanStages.MODEL */ .W6.MODEL,
    planDetails: components_newPlan_constants__WEBPACK_IMPORTED_MODULE_0__/* .policyDetailsInitState */ .c8,
    legalDetailsUploadedStatus: null,
    loggedUserRole: "",
    gstDetailsValid: true,
    gstDetailsSubmitAction: true,
    formConfigsMap: {},
    userAccessList: [],
    setPlanDetails: function() {},
    setUserAccessList: function() {},
    setActiveStage: function() {},
    setPermissions: function() {},
    setUserDetails: function() {},
    setPartnerId: function() {},
    setShowHamburger: function() {},
    setSnackbar: function() {},
    setLoggedUserRole: function() {},
    setLegalDetailsUploadedStatus: function() {},
    setGstDetailsValid: function() {},
    setMetaData: function() {},
    setPermissionsMap: function() {},
    setGstDetailsSubmitAction: function() {},
    setFormConfigsMap: function() {}
});


/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lO": function() { return /* binding */ setTrackerIdCookie; },
/* harmony export */   "yx": function() { return /* binding */ setIframeUserIdCookie; }
/* harmony export */ });
/* unused harmony exports getCookiesMap, getCookieUserId, parseHeaderCookies */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1955);
/* harmony import */ var utils_generics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3949);


/* eslint-disable prefer-destructuring */ function getCookiesMap(cookiesString) {
    return cookiesString.split(";").map(function(cookieString) {
        return cookieString.trim().split("=");
    }).reduce(function(acc, curr) {
        acc[curr[0]] = curr[1];
        return acc;
    }, {});
}
function getCookieUserId(cookiesString) {
    var cookie = getCookiesMap(cookiesString);
    if (cookie === null || cookie === void 0 ? void 0 : cookie.user_id) {
        return cookie["user_id"];
    }
    return "";
}
function parseHeaderCookies(cookies) {
    try {
        var ref;
        var parsedCookies = {};
        (ref = cookies === null || cookies === void 0 ? void 0 : cookies.split(";")) === null || ref === void 0 ? void 0 : ref.forEach(function(cookie) {
            var parts = cookie.match(/(.*?)=(.*)$/);
            if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) {
                var ref;
                parsedCookies[(ref = parts[1]) === null || ref === void 0 ? void 0 : ref.trim()] = (parts[2] || "").trim();
            }
        });
        return parsedCookies;
    } catch (e) {
        console.error("parse header cookie: ", e);
        return {};
    }
}
function setIframeUserIdCookie() {
    var ref, ref1;
    var view = (ref = new URL(window.location.href)) === null || ref === void 0 ? void 0 : (ref1 = ref.searchParams) === null || ref1 === void 0 ? void 0 : ref1.get("view");
    var localView = localStorage.getItem("view");
    if (view === "iframe" || localView === "iframe") {
        var userId = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("user_id") || localStorage.getItem("userId");
        var userAuthKey = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("user_auth_key");
        if (userAuthKey) {
            document.cookie = "user_auth_key=".concat(userAuthKey, ";samesite=none;secure;expires=Tue, 19 Jan 2038 03:14:07 GMT;path=/");
        }
        if (userId) document.cookie = "user_id=".concat(userId, ";samesite=none;secure;expires=Tue, 19 Jan 2038 03:14:07 GMT;path=/");
    }
}
function setTrackerIdCookie() {
    // Check if tracker_id cookie already exists
    var existingTrackerId = (js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === null || js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === void 0 ? void 0 : js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("trackerid")) || "";
    if (!existingTrackerId) {
        // Generate a unique tracker ID using the existing uuid utility
        var trackerId = (0,utils_generics__WEBPACK_IMPORTED_MODULE_1__/* .uuid */ .Vj)(32);
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === null || js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z === void 0 ? void 0 : js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("trackerid", trackerId);
    }
}


/***/ }),

/***/ 3949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "El": function() { return /* binding */ getCoverage; },
/* harmony export */   "Hc": function() { return /* binding */ isAnyKeyEmpty; },
/* harmony export */   "Vj": function() { return /* binding */ uuid; },
/* harmony export */   "m4": function() { return /* binding */ getImageBasePath; },
/* harmony export */   "oX": function() { return /* binding */ whatsCoverText; },
/* harmony export */   "s0": function() { return /* binding */ getPlanName; },
/* harmony export */   "xb": function() { return /* binding */ isEmpty; }
/* harmony export */ });
/* unused harmony export getTncLink */
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1485);

/* eslint-disable no-plusplus */ var getImageBasePath = function(imagePath) {
    var imageStaticPath =  true ? "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
    var basePath = imageStaticPath ? "".concat(imageStaticPath, "/_next_static") : "/_next_static";
    if (basePath === "/_next_static") {
        return imagePath;
    }
    return "".concat(basePath).concat(imagePath);
};
var getTncLink = function() {
    try {
        var staticPath =  true ? "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
        return "".concat(staticPath, "/_next_static/static/dealer_tnc.html");
    } catch (e) {
        return "/_next_static/static/dealer_tnc.html";
    }
};
var uuid = function(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for(var i = 0; i < length; i++){
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
var getCoverage = function(plan) {
    try {
        if (plan.includes("Screen Damage")) {
            return [
                utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ScreenDamage */ .qI
            ];
        }
        if (plan.includes("Comprehensive")) {
            return [
                utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .LiquidDamage */ ._B,
                utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .AccidentalDamage */ .s7
            ];
        }
        if (plan.includes("Extended Warranty")) {
            return [
                utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ElectronicsFailure */ .ki
            ];
        }
        return [];
    } catch (e) {
        return [];
    }
};
var whatsCoverText = function(plan) {
    try {
        if (plan === null || plan === void 0 ? void 0 : plan.includes("screen damage")) {
            return "Screen damage";
        }
        if (plan === null || plan === void 0 ? void 0 : plan.includes("comprehensive")) {
            return "Screen damage with liquid damage";
        }
        if ((plan === null || plan === void 0 ? void 0 : plan.includes("extended warranty")) || (plan === null || plan === void 0 ? void 0 : plan.includes("_ew"))) {
            return "Electronical & mechanical failures";
        }
        return "-";
    } catch (e) {
        return "-";
    }
};
var getPlanName = function(plan) {
    try {
        if (plan === null || plan === void 0 ? void 0 : plan.includes("SD")) {
            return "Screen damage protection";
        }
        if (plan === null || plan === void 0 ? void 0 : plan.includes("ADLD")) {
            return "Total damage protection";
        }
        if (plan === null || plan === void 0 ? void 0 : plan.includes("DEC")) {
            return "Extended Warranty Plan - Dec'22 - Nov'23 Sale";
        }
        if (plan === null || plan === void 0 ? void 0 : plan.includes("EW")) {
            return "Extended Warranty Offer for Current Month";
        }
        return plan;
    } catch (e) {
        return plan;
    }
};
function isEmpty(value) {
    var isEmpty = true;
    Object.values(value).forEach(function(val) {
        if (val) isEmpty = false;
    });
    return isEmpty;
}
function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, options = arguments.length > 2 ? arguments[2] : void 0;
    var invokeFunc = function invokeFunc(time) {
        var args = lastArgs;
        var thisArg = lastThis;
        lastThis = undefined;
        lastArgs = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    };
    var trailingEdge = function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastThis = undefined;
        lastArgs = undefined;
        return result;
    };
    var shouldInvoke = function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime;
        var timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    };
    var remainingWait = function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime;
        var timeSinceLastInvoke = time - lastInvokeTime;
        var timeWaiting = wait - timeSinceLastCall;
        return maxing ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    };
    var leadingEdge = function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    };
    var cancel = function cancel() {
        if (timerId !== undefined) {
            clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastThis = undefined;
        lastArgs = undefined;
        lastCallTime = undefined;
        timerId = undefined;
    };
    var flush = function flush() {
        return timerId === undefined ? result : trailingEdge(Date.now());
    };
    var debounced = function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var time = Date.now();
        var isInvoking = shouldInvoke(time);
        lastArgs = args;
        // eslint-disable-next-line
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
        }
        return result;
    };
    var lastArgs;
    var lastThis;
    var maxWait;
    var result;
    var timerId;
    var lastCallTime;
    var lastInvokeTime = 0;
    var leading = false;
    var maxing = false;
    var trailing = true;
    if (typeof func !== "function") {
        throw new TypeError("Expected a function");
    }
    function timerExpired() {
        var time = Date.now();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
        return null;
    }
    if (typeof options === "object") {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? Math.max(Number(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var isAnyKeyEmpty = function(value) {
    var isEmpty = false;
    Object.values(value).forEach(function(val) {
        if (!val) isEmpty = true;
    });
    return isEmpty;
};


/***/ }),

/***/ 1272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ bootstrapUserPermissions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_newPlan_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5327);
/* harmony import */ var components_login_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2186);
/* harmony import */ var utils_api_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1349);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1485);
/* harmony import */ var utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4733);









function bootstrapUserPermissions(_) {
    return _bootstrapUserPermissions.apply(this, arguments);
}
function _bootstrapUserPermissions() {
    _bootstrapUserPermissions = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var router, partnerId, groupName, setPermissions, setUserDetails, setMetaData, setPartnerId, setShowErrorScreen, setPermissionsMap, setDealerType, setLoggedUserRole, setLegalDetailsUploadedStatus, setActiveStage, setGstDetailsValid, setGstDetailsSubmitAction, setFormConfigsMap, setSnackbar, setErrorMessage, setIsLoading, ref, status, data, ref1, ref2, ref3, permissions, user_details, meta_data, permissionsMap, lobPrefix, user_role, ref4, statusCode, formConfigs, newFormConfigsMap, dealerDetailsForm, should_capture_details, details_update_required, e, ref5, ref6, ref7, ref8, financialDetailsData, financialStatus, details_required, details_present, can_submit, gstValidationResponse, _data, required, valid, can_submit1, e1, ref9, ref10, ref11, errorMessage, e2, ref12, ref13, ref14, errorMessage1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    router = param.router, partnerId = param.partnerId, groupName = param.groupName, setPermissions = param.setPermissions, setUserDetails = param.setUserDetails, setMetaData = param.setMetaData, setPartnerId = param.setPartnerId, setShowErrorScreen = param.setShowErrorScreen, setPermissionsMap = param.setPermissionsMap, setDealerType = param.setDealerType, setLoggedUserRole = param.setLoggedUserRole, setLegalDetailsUploadedStatus = param.setLegalDetailsUploadedStatus, setActiveStage = param.setActiveStage, setGstDetailsValid = param.setGstDetailsValid, setGstDetailsSubmitAction = param.setGstDetailsSubmitAction, setFormConfigsMap = param.setFormConfigsMap, setSnackbar = param.setSnackbar, setErrorMessage = param.setErrorMessage, setIsLoading = param.setIsLoading;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        13,
                        ,
                        14
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getDomainOrigin */ .IY)(), "/api/mpos/partner/").concat(partnerId, "/user-permissions?group_name=").concat(groupName)
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 2:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (!(status === 200 && (data === null || data === void 0 ? void 0 : data.permissions))) return [
                        3,
                        12
                    ];
                    permissions = data.permissions, user_details = data.user_details, meta_data = data.meta_data;
                    setPermissions(permissions);
                    setUserDetails(user_details);
                    setMetaData(meta_data);
                    setPartnerId(user_details === null || user_details === void 0 ? void 0 : user_details.partner_id);
                    setShowErrorScreen(false);
                    permissionsMap = {};
                    permissions === null || permissions === void 0 ? void 0 : (ref1 = permissions.permission_list) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(permission) {
                        permissionsMap[permission] = true;
                    });
                    setPermissionsMap(permissionsMap);
                    if (setDealerType) {
                        setDealerType((permissions === null || permissions === void 0 ? void 0 : permissions.role) || "");
                    }
                    if (permissions === null || permissions === void 0 ? void 0 : permissions.lob) {
                        lobPrefix = permissions.lob;
                    } else {
                        lobPrefix = utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .autoLobPartners.includes */ .co.includes(user_details.partner_id) || permissions.permission_list.includes("access_only_auto_commercial_flow") ? "auto-lob" : utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .autoPartnershipPartners.includes */ .ZO.includes(user_details.partner_id) ? "auto-partnership" : "embedded";
                    }
                    if (router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.slug) === null || ref3 === void 0 ? void 0 : ref3.includes("thankyou")) {
                        setIsLoading(false);
                        return [
                            2
                        ];
                    }
                    user_role = permissions.group;
                    if (!(user_details === null || user_details === void 0 ? void 0 : user_details.partner_id) || !user_role) {
                        setIsLoading(false);
                        router.push("/partners");
                        return [
                            2
                        ];
                    }
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getDomainOrigin */ .IY)(), "/api/mpos/genie/onboarding/").concat(user_details.partner_id, "/details/status?user_group=").concat(user_role)
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 4:
                    ref4 = _state.sent(), statusCode = ref4.status, formConfigs = ref4.data;
                    if (statusCode === 200 && Array.isArray(formConfigs)) {
                        newFormConfigsMap = (0,components_login_helpers__WEBPACK_IMPORTED_MODULE_8__/* .mapFormConfigs */ .c)(formConfigs);
                        if (setFormConfigsMap) {
                            setFormConfigsMap(newFormConfigsMap);
                        }
                        dealerDetailsForm = newFormConfigsMap[utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .FORM_TYPES.DEALER_DETAILS */ .dz.DEALER_DETAILS];
                        if (dealerDetailsForm) {
                            should_capture_details = dealerDetailsForm.should_capture_details, details_update_required = dealerDetailsForm.details_update_required;
                            if (should_capture_details || details_update_required) {
                                setIsLoading(false);
                                router.push("/".concat(lobPrefix, "/").concat(user_details.partner_id, "/dealer-details"));
                                return [
                                    2
                                ];
                            }
                        }
                    }
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    if ((e === null || e === void 0 ? void 0 : (ref5 = e.response) === null || ref5 === void 0 ? void 0 : ref5.status) === 404) {
                        ;
                        setErrorMessage(e === null || e === void 0 ? void 0 : (ref6 = e.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.message);
                    }
                    setShowErrorScreen(true);
                    setIsLoading(false);
                    return [
                        2
                    ];
                case 6:
                    _state.trys.push([
                        6,
                        11,
                        ,
                        12
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getDomainOrigin */ .IY)(), "/api/mpos/").concat(user_details.partner_id, "/financial-details/exists?group_name=").concat(user_role)
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_4__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 7:
                    ref8 = _state.sent(), financialDetailsData = ref8.data, financialStatus = ref8.status;
                    if (!(financialStatus === 200 && financialDetailsData)) return [
                        3,
                        10
                    ];
                    details_required = financialDetailsData.details_required, details_present = financialDetailsData.details_present, can_submit = financialDetailsData.can_submit;
                    setLoggedUserRole(user_role);
                    if (details_required && !details_present) {
                        setLegalDetailsUploadedStatus(true);
                        if (can_submit) {
                            setActiveStage(components_newPlan_constants__WEBPACK_IMPORTED_MODULE_1__/* .NewPlanStages.LEGAL_DOCUMENTS_UPLOAD */ .W6.LEGAL_DOCUMENTS_UPLOAD);
                            setIsLoading(false);
                            router.push("/".concat(lobPrefix, "/").concat(user_details.partner_id, "/legal-documents"));
                            return [
                                2
                            ];
                        }
                        if (user_role === "sub_dealer") {
                            setIsLoading(false);
                            router.push("/".concat(lobPrefix, "/").concat(user_details.partner_id, "/dashboard"));
                            return [
                                2
                            ];
                        }
                    }
                    if (permissions.permission_list.includes("access_only_auto_commercial_flow")) {
                        setIsLoading(false);
                        router.push("/".concat(lobPrefix, "/").concat(user_details.partner_id, "/form"));
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        (0,utils_api_services__WEBPACK_IMPORTED_MODULE_2__.callValidateGSTDetails)(user_details.partner_id, user_role, true)
                    ];
                case 8:
                    gstValidationResponse = _state.sent();
                    if (!gstValidationResponse.is_error) {
                        if (gstValidationResponse.data) {
                            _data = gstValidationResponse.data, required = _data.required, valid = _data.valid, can_submit1 = _data.can_submit;
                            if (required && !valid) {
                                setGstDetailsValid(false);
                            } else {
                                setGstDetailsValid(true);
                            }
                            setGstDetailsSubmitAction(can_submit1);
                        }
                    } else {
                        setSnackbar({
                            type: "failure",
                            message: "Failed to validate GST Details"
                        });
                    }
                    setIsLoading(false);
                    return [
                        4,
                        router.replace("/".concat(lobPrefix, "/").concat(user_details.partner_id, "/dashboard"))
                    ];
                case 9:
                    _state.sent();
                    return [
                        2
                    ];
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    e1 = _state.sent();
                    if ((e1 === null || e1 === void 0 ? void 0 : (ref9 = e1.response) === null || ref9 === void 0 ? void 0 : ref9.status) === 401) {
                        setIsLoading(false);
                        router.push("/login");
                        return [
                            2
                        ];
                    }
                    errorMessage = e1 === null || e1 === void 0 ? void 0 : (ref10 = e1.response) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.message;
                    setErrorMessage(errorMessage);
                    setShowErrorScreen(true);
                    setIsLoading(false);
                    return [
                        3,
                        12
                    ];
                case 12:
                    return [
                        3,
                        14
                    ];
                case 13:
                    e2 = _state.sent();
                    if ((e2 === null || e2 === void 0 ? void 0 : (ref12 = e2.response) === null || ref12 === void 0 ? void 0 : ref12.status) === 401) {
                        setSnackbar({
                            type: "failure",
                            message: "Token expired. Redirecting to login page"
                        });
                        setIsLoading(false);
                        router.push("/login");
                        return [
                            2
                        ];
                    }
                    errorMessage1 = e2 === null || e2 === void 0 ? void 0 : (ref13 = e2.response) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.data) === null || ref14 === void 0 ? void 0 : ref14.message;
                    setErrorMessage(errorMessage1);
                    setShowErrorScreen(true);
                    setIsLoading(false);
                    return [
                        3,
                        14
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
    return _bootstrapUserPermissions.apply(this, arguments);
}


/***/ }),

/***/ 1187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getGroup; },
/* harmony export */   "w": function() { return /* binding */ getProduct; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1485);
/* harmony import */ var utils_segment_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7316);


function getGroup(partnerGroupName, partnerId) {
    var prefixWithUnderscore = "".concat(partnerId, "_");
    if (partnerGroupName.startsWith(prefixWithUnderscore)) {
        return partnerGroupName.slice(prefixWithUnderscore.length);
    }
    return "";
}
function getProduct(partnerId) {
    return partnerId === utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .Partners.HERO_VIDA */ .wV.HERO_VIDA ? utils_segment_constants__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT.AUTO */ .c5.AUTO : utils_segment_constants__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT.ELECTRONICS */ .c5.ELECTRONICS;
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ fetchUserAccess; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_serverConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4733);





function fetchUserAccess() {
    return _fetchUserAccess.apply(this, arguments);
}
function _fetchUserAccess() {
    _fetchUserAccess = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var ref, status, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            method: "GET",
                            url: "".concat((0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_1__/* .getDomainOrigin */ .IY)(), "/api/mpos/user/access")
                        }, (0,utils_serverConfig__WEBPACK_IMPORTED_MODULE_1__/* .getAxiosConfig */ .uZ)()))
                    ];
                case 1:
                    ref = _state.sent(), status = ref.status, data = ref.data;
                    if (status === 200) {
                        return [
                            2,
                            {
                                user_access: (data === null || data === void 0 ? void 0 : data.user_access) || [],
                                user_details: (data === null || data === void 0 ? void 0 : data.user_details) || null
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            user_access: [],
                            user_details: null
                        }
                    ];
            }
        });
    });
    return _fetchUserAccess.apply(this, arguments);
}


/***/ }),

/***/ 1246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ clearPartnerNavState; },
/* harmony export */   "Fu": function() { return /* binding */ getUserAccess; },
/* harmony export */   "I0": function() { return /* binding */ PARTNER_NAV_STATES; },
/* harmony export */   "Xr": function() { return /* binding */ saveUserAccess; },
/* harmony export */   "gu": function() { return /* binding */ getPartnerContext; },
/* harmony export */   "o_": function() { return /* binding */ getPartnerNavState; },
/* harmony export */   "po": function() { return /* binding */ savePartnerContext; },
/* harmony export */   "sy": function() { return /* binding */ setPartnerNavState; }
/* harmony export */ });
/* unused harmony exports setSwitchBrandRequested, consumeSwitchBrandRequested */
var ACCESS_KEY = "user_partner_access";
var CONTEXT_KEY = "selected_partner_context";
var SWITCH_BRAND_KEY = "switch_brand_requested";
var NAV_STATE_KEY = "partner_nav_state";
var PARTNER_NAV_STATES = {
    NONE: "none",
    SELECTING: "selecting"
};
function saveUserAccess(access) {
    localStorage.setItem(ACCESS_KEY, JSON.stringify(access !== null && access !== void 0 ? access : []));
}
function getUserAccess() {
    try {
        var data = localStorage.getItem(ACCESS_KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        return [];
    }
}
function savePartnerContext(partnerId, group) {
    var context = {
        partner_id: partnerId,
        group: group
    };
    localStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
}
function getPartnerContext() {
    try {
        var data = localStorage.getItem(CONTEXT_KEY);
        return data ? JSON.parse(data) : null;
    } catch (e) {
        return null;
    }
}
function setSwitchBrandRequested() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    localStorage.setItem(SWITCH_BRAND_KEY, value ? "1" : "0");
}
function consumeSwitchBrandRequested() {
    try {
        var value = localStorage.getItem(SWITCH_BRAND_KEY) === "1";
        localStorage.removeItem(SWITCH_BRAND_KEY);
        return value;
    } catch (e) {
        return false;
    }
}
function setPartnerNavState(state) {
    localStorage.setItem(NAV_STATE_KEY, state);
}
function getPartnerNavState() {
    return localStorage.getItem(NAV_STATE_KEY) || PARTNER_NAV_STATES.NONE;
}
function clearPartnerNavState() {
    localStorage.removeItem(NAV_STATE_KEY);
}


/***/ }),

/***/ 1798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useViewport; },
/* harmony export */   "j": function() { return /* binding */ ViewportProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* eslint-disable react/jsx-no-constructed-context-values */ 

var viewportContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isMobile: true
});
function ViewportProvider(param) {
    var children = param.children, isMobileDevice = param.isMobileDevice;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isMobileDevice), isMobile = ref[0], setIsMobile = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleWindowResize = function handleWindowResize(e) {
            // Check if the media query is true
            if (e.matches) {
                // Then log the following message to the console
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };
        // Create a condition that targets viewports at least 768px wide
        var mediaQuery = window.matchMedia("(max-width: 768px)");
        // Register event listener
        mediaQuery.addListener(handleWindowResize);
        // Initial check
        handleWindowResize(mediaQuery);
        return function() {
            return mediaQuery.removeListener(handleWindowResize);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(viewportContext.Provider, {
        value: {
            isMobile: isMobile
        },
        children: children
    });
}
var useViewport = function() {
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(viewportContext).isMobile;
    return {
        isMobile: isMobile
    };
};



/***/ }),

/***/ 7316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ SegmentEventButtonNames; },
/* harmony export */   "IT": function() { return /* binding */ SegmentPages; },
/* harmony export */   "Jk": function() { return /* binding */ SegmentTrackEvents; },
/* harmony export */   "OX": function() { return /* binding */ SegmentEventFieldTypes; },
/* harmony export */   "Pg": function() { return /* binding */ SegmentEventNameTypes; },
/* harmony export */   "Qy": function() { return /* binding */ SegmentEventActionTypes; },
/* harmony export */   "c5": function() { return /* binding */ PRODUCT; },
/* harmony export */   "g0": function() { return /* binding */ SegmentEventPages; },
/* harmony export */   "iV": function() { return /* binding */ SegmentEventActionNames; },
/* harmony export */   "od": function() { return /* binding */ SegmentViewEvents; },
/* harmony export */   "s9": function() { return /* binding */ SegmentEventPageTypes; },
/* harmony export */   "tM": function() { return /* binding */ SUB_PRODUCT_NAME; },
/* harmony export */   "vn": function() { return /* binding */ SegmentEventActions; }
/* harmony export */ });
var SegmentViewEvents;
(function(SegmentViewEvents) {
    SegmentViewEvents["VIEW_LOGIN_DEALER"] = "view_login_dealer";
    SegmentViewEvents["VIEW_OTP_LOGIN_DEALER"] = "view_otp_login_dealer";
    SegmentViewEvents["VIEW_HOMEPAGE_DEALER"] = "view_homepage_dealer";
    SegmentViewEvents["VIEW_DEVICE_MODEL"] = "view_device_model";
    SegmentViewEvents["VIEW_PLAN"] = "view_plan";
    SegmentViewEvents["VIEW_SERIAL_NUMBER_SCAN"] = "view_serial_number_scan";
    SegmentViewEvents["VIEW_UPLOAD_DOCUMENTS"] = "view_upload_documents";
    SegmentViewEvents["VIEW_CUSTOMER_LINK_SHARE"] = "view_customer_link_share_page";
    SegmentViewEvents["VIEW_DEALER_WAITING_FOR_PAYMENT"] = "view_dealer_waiting_for_payment";
    SegmentViewEvents["VIEW_DEALER_PAYMENT"] = "view_dealer_payment";
    SegmentViewEvents["VIEW_HAMBURGER_SCREEN"] = "view_hamburger_screen";
    SegmentViewEvents["VIEW_ADD_REMOVE_SUB_DEALER"] = "view_add_remove_sub_deader";
    SegmentViewEvents["VIEW_CONFIRM_SUB_DEALER"] = "view_confirm_sub_dealer";
    SegmentViewEvents["VIEW_MY_TRANSACTIONS"] = "view_my_transactions";
    SegmentViewEvents["VIEW_PAYMENT_SUCCESS"] = "view_payment_success";
    SegmentViewEvents["VIEW_PAYMENT_FAILURE"] = "view_payment_failure";
    SegmentViewEvents[// specific to ather
    "VIEW_VEHICLE_DETAILS"] = "view_vehicle_details";
    SegmentViewEvents["VIEW_CUSTOMER_DETAILS"] = "view_customer_details";
    SegmentViewEvents["REVIEW_DETAILS"] = "view_review_details";
})(SegmentViewEvents || (SegmentViewEvents = {}));
var SegmentTrackEvents;
(function(SegmentTrackEvents) {
    SegmentTrackEvents["TAP_LOGIN"] = "tap_login";
    SegmentTrackEvents["TAP_CTA_CREATE_NEW_PLAN"] = "tap_cta_create_new_plan";
    SegmentTrackEvents["TAP_CTA_PENDING"] = "tap_cta_pending";
    SegmentTrackEvents["TAP_CTA_COMPLETED"] = "tap_cta_completed";
    SegmentTrackEvents["TAP_CTA_MENU"] = "tap_cta_menu";
    SegmentTrackEvents["TAP_CTA_LINK_SENT"] = "tap_cta_link_sent";
    SegmentTrackEvents["TAP_CTA_DEALER_PAYMENT"] = "tap_cta_dealer_payment";
    SegmentTrackEvents["TAP_CTA_RESEND_LINK"] = "tap_cta_resend_link";
    SegmentTrackEvents["TAP_CTA_PAY_ACKO"] = "tap_cta_pay_acko";
    SegmentTrackEvents["TAP_CTA_SELECT_MODEL"] = "tap_cta_select_model";
    SegmentTrackEvents["TAP_BTN_SELECT_PLAN"] = "tap_btn_select_plan";
    SegmentTrackEvents["TAP_LBL_TYPE_SERIAL_NUMBER"] = "tap_lbl_type_serial_number";
    SegmentTrackEvents["TAP_LBL_CONFIRM_SERIAL_NUMBER"] = "tap_lbl_confirm_serial_number";
    SegmentTrackEvents["TAP_CONTINUE_SERIAL_NUMBER_SCAN_PAGE"] = "tap_continue_serial_number_scan_page";
    SegmentTrackEvents["TAP_SUBMIT_SERIAL_NUMBER_MODEL_PAGE"] = "tap_submit_serial_number_model_page";
    SegmentTrackEvents["TAP_CTA_UPLOAD_INVOICE"] = "tap_cta_upload_invoice";
    SegmentTrackEvents["TAP_CTA_UPLOAD_BOX_IMAGE"] = "tap_cta_upload_box_image";
    SegmentTrackEvents["TAP_CONTINUE_UPLOAD_DOCUMENTS_PAGE"] = "tap_continue_upload_documents_page";
    SegmentTrackEvents["TAP_BTN_SEND_TO_CUSTOMER"] = "tap_btn_send_to_customer";
    SegmentTrackEvents["TAP_BTN_GO_HOME"] = "tap_btn_go_home";
    SegmentTrackEvents["TAP_MY_TRANSACTION"] = "tap_my_transaction";
    SegmentTrackEvents["TAP_ADD_REMOVE_SUB_DEALERS"] = "tap_add_remove_sub_dealers";
    SegmentTrackEvents["TAP_CONFIRM_SUB_DEALER"] = "tap_confirm_sub_dealer";
    SegmentTrackEvents["TAP_CTA_EDIT_MODEL"] = "tap_cta_edit_model";
    SegmentTrackEvents[// ather
    "TAP_CONTINUE_VEHICLE_DETAILS"] = "tap_continue_vehicle_details";
    SegmentTrackEvents["TAP_CONTINUE_CUSTOMER_DETAILS"] = "tap_continue_customer_details";
    SegmentTrackEvents["TAP_ISSUE_POLICY"] = "tap_issue_policy_review_details";
})(SegmentTrackEvents || (SegmentTrackEvents = {}));
var SegmentPages;
(function(SegmentPages) {
    SegmentPages["LOGIN"] = "login";
    SegmentPages["LOGIN_OTP"] = "login_otp";
    SegmentPages["DASHBOARD"] = "dashboard";
    SegmentPages["NEW_PLAN_DEVICE_MODELS"] = "new-plan-device-models";
    SegmentPages["NEW_PLAN_PLANS"] = "new-plan-plans";
    SegmentPages["NEW_PLAN_SERIAL_NUMBER"] = "new-plan-serial-number";
    SegmentPages["NEW_PLAN_DOCUMENT_UPLOAD"] = "new-plan-document-upload";
    SegmentPages["NEW_PLAN_SEND_LINK_TO_CUSTOMER"] = "new-plan-send-link-to-customer";
    SegmentPages["NEW_PLAN_CONGRATULATIONS"] = "new-plan-congratulations";
    SegmentPages["MANAGE_DEALERS"] = "manage-dealers";
    SegmentPages["ADD_SUB_DEALER"] = "add-sub-dealer";
    SegmentPages["PAYMENT"] = "payment";
    SegmentPages["TRANSACTIONS"] = "transactions";
    SegmentPages["THANKYOU"] = "thankyou";
    SegmentPages["PROFILE"] = "profile";
    SegmentPages["LOGOUT"] = "logout";
    SegmentPages["CUSTOMER_DETAIALS"] = "customer-details";
    SegmentPages["VEHICLE_DETAILS"] = "vehicle-details";
    SegmentPages["REVIEW_DETAILS"] = "review-details";
})(SegmentPages || (SegmentPages = {}));
var SegmentEventNameTypes;
(function(SegmentEventNameTypes) {
    SegmentEventNameTypes["VIEW"] = "view";
    SegmentEventNameTypes["ACTION"] = "action";
    SegmentEventNameTypes["EXCEPTION"] = "exception";
})(SegmentEventNameTypes || (SegmentEventNameTypes = {}));
var SegmentEventPages;
(function(SegmentEventPages) {
    SegmentEventPages["VIEW_VEHICLE_DETAILS_PAGE"] = "view_vehicle_details_page";
    SegmentEventPages["COMMISSION_EARNED_V1_PAGE"] = "commission_earned_v1_page";
    SegmentEventPages["GENERATE_REPORT_INFO_POPUP"] = "generate_report_info_popup";
    SegmentEventPages["VIEW_PAGE"] = "view_page";
    SegmentEventPages["VIEW_LOGIN_PAGE"] = "view_login_page";
    SegmentEventPages["VIEW_LOGIN_OTP"] = "view_login_otp";
    SegmentEventPages["VIEW_HOMEPAGE_DEALER"] = "view_homepage_dealer";
    SegmentEventPages["VIEW_HAMBURGER_SCREEN"] = "view_hamburger_screen";
    SegmentEventPages["VIEW_MY_TRANSACTIONS"] = "view_my_transactions";
    SegmentEventPages["VIEW_REPORT_DASHBORD"] = "view_report_dashboard";
    SegmentEventPages["VIEW_COMMISSIONS_EARNED_V1_PAGE"] = "view_commissions_earned_v1_page";
    SegmentEventPages["VIEW_ADD_REMOVE_SUB_DEALER"] = "view_add_remove_sub_dealer";
    SegmentEventPages["VIEW_CONFIRM_SUB_DEALER"] = "view_confirm_sub_dealer";
    SegmentEventPages["VIEW_DEVICE_MODEL"] = "view_device_model";
    SegmentEventPages["VIEW_PLAN"] = "view_plan";
    SegmentEventPages["VIEW_PAYMENT_PAGE"] = "view_payment_page";
    SegmentEventPages["VIEW_MAIN_PAGE"] = "view_main_page";
    SegmentEventPages["VIEW_TRANSACTION_DETAIL_MODAL"] = "view_transaction_detail_modal";
    SegmentEventPages["VIEW_VEHICLE_VALIDATION_PAGE"] = "view_vehicle_validation_page";
    SegmentEventPages["VIEW_CUSTOMER_DETAILS_PAGE"] = "view_customer_details_page";
    SegmentEventPages["VIEW_REVIEW_DETAILS_PAGE"] = "view_review_details_page";
    SegmentEventPages["VIEW_SEND_LINK_TO_CUSTOMER_PAGE"] = "view_send_link_to_customer_page";
    SegmentEventPages["VIEW_CONGRATULATIONS_PAGE"] = "view_congratulations_page";
    SegmentEventPages["VIEW_DEALER_DETAILS_PAGE"] = "view_dealer_details_page";
    SegmentEventPages["VIEW_CONFIRMATION_MODAL"] = "view_confirmation_modal";
})(SegmentEventPages || (SegmentEventPages = {}));
var SegmentEventActions;
(function(SegmentEventActions) {
    SegmentEventActions["TAP_DATE_TO_DATE_RANGE"] = "tap_date_to_date_range";
    SegmentEventActions["TAP_DATE_FROM_DATE_RANGE"] = "tap_date_from_date_range";
    SegmentEventActions["TAP_GROUPBY"] = "tap_groupby";
    SegmentEventActions["TAP_SUB_DEALER_SEARCH"] = "tap_sub_dealer_search";
    SegmentEventActions["TAP_SUB_DEALER_NAME"] = "tap_sub_dealer_name";
    SegmentEventActions["TAP_REPORT_HISTORY_TAB"] = "tap_report_history_tab";
    SegmentEventActions["TAP_REPORTS_TAB"] = "tap_reports_tab";
    SegmentEventActions["TAP_GENERATE_BTN"] = "tap_generate_btn";
    SegmentEventActions["TAP_REFRESH_BTN"] = "tap_refresh_btn";
    SegmentEventActions["TAP_DOWNLOAD_BTN"] = "tap_download_btn";
    SegmentEventActions["TAP_GENERATE_REPORT_INFO_BTN_OK"] = "tap_generate_report_info_btn_ok";
})(SegmentEventActions || (SegmentEventActions = {}));
var SegmentEventActionTypes;
(function(SegmentEventActionTypes) {
    SegmentEventActionTypes["TAP_BTN"] = "tap_btn";
    SegmentEventActionTypes["TAP_CALENDER"] = "tap_calender";
    SegmentEventActionTypes["TAP_DROPDOWN"] = "tap_dropdown";
    SegmentEventActionTypes["TAP_CHECKBOX"] = "tap_checkbox";
    SegmentEventActionTypes["TAP_SEARCH"] = "tap_search";
    SegmentEventActionTypes["ENTER_TEXT"] = "enter_text";
})(SegmentEventActionTypes || (SegmentEventActionTypes = {}));
var PRODUCT = {
    ELECTRONICS: "electronics",
    AUTO: "auto"
};
var SUB_PRODUCT_NAME = "pos";
var SegmentEventButtonNames;
(function(SegmentEventButtonNames) {
    SegmentEventButtonNames["LOGIN"] = "login";
    SegmentEventButtonNames["MENU"] = "menu";
    SegmentEventButtonNames["CREATE_NEW_PLAN"] = "create_new_plan";
    SegmentEventButtonNames["MY_TRANSACTION"] = "my_transaction";
    SegmentEventButtonNames["REPORT_DASHBOARD"] = "report_dashboard";
    SegmentEventButtonNames["CONTACT_US"] = "contact_us";
    SegmentEventButtonNames["ADD_REMOVE_SUB_DEALER"] = "add_remove_sub_dealer";
    SegmentEventButtonNames["CONFIRM_SUB_DEALER"] = "confirm_sub_dealer";
    SegmentEventButtonNames["SELECT_MODEL"] = "select_model";
    SegmentEventButtonNames["SELECT_PLAN"] = "select_plan";
    SegmentEventButtonNames["CLICK_SERIAL_NUMBER"] = "click_serial_number";
    SegmentEventButtonNames["CLICK_VIN_NUMBER"] = "click_vin_number";
    SegmentEventButtonNames["SELECT_TRANSACTIONS_TYPE"] = "select_transactions_type";
    SegmentEventButtonNames["CONTINUE_FROM_CUSTOMER_DETAILS"] = "continue_from_customer_details";
    SegmentEventButtonNames["CONTINUE_FROM_VEHICLE_DETAILS"] = "continue_from_vehicle_details";
    SegmentEventButtonNames["CLICK_EDIT_MODEL"] = "click_edit_model";
    SegmentEventButtonNames["SEND_TO_CUSTOMER"] = "send_to_customer";
    SegmentEventButtonNames["GO_HOME_BUTTON"] = "go_home_button";
    SegmentEventButtonNames["SUBMIT_MODAL"] = "submit_modal";
    SegmentEventButtonNames["CANCEL_MODAL"] = "cancel_modal";
    SegmentEventButtonNames["DETAILS"] = "details";
    SegmentEventButtonNames["DETAILS_BACK_BUTTON"] = "details_back_button";
    SegmentEventButtonNames["SUBMIT"] = "submit";
})(SegmentEventButtonNames || (SegmentEventButtonNames = {}));
var SegmentEventActionNames;
(function(SegmentEventActionNames) {
    SegmentEventActionNames["LOGIN_ATTEMPT"] = "login_attempt";
    SegmentEventActionNames["CLICK_MENU"] = "click_menu";
    SegmentEventActionNames["CREATE_NEW_PLAN"] = "create_new_plan";
    SegmentEventActionNames["CLICK_MY_TRANSACTIONS"] = "click_my_transactions";
    SegmentEventActionNames["CLICK_REPORT_DASHBOARD"] = "click_report_dashboard";
    SegmentEventActionNames["CLICK_CONTACT_US"] = "click_contact_us";
    SegmentEventActionNames["CLICK_ADD_REMOVE_SUB_DEALERS"] = "click_add_remove_sub_dealers";
    SegmentEventActionNames["CLICK_CONFIRM_SUB_DEALERS"] = "click_confirm_sub_dealers";
    SegmentEventActionNames["SELECT_MODEL"] = "select_model";
    SegmentEventActionNames["SELECT_PLAN"] = "select_plan";
    SegmentEventActionNames["CLICK_SERIAL_NUMBER"] = "click_serial_number";
    SegmentEventActionNames["CLICK_VIN_NUMBER"] = "click_vin_number";
    SegmentEventActionNames["CLICK_TRANSACTION_ITEM"] = "click_transaction_item";
    SegmentEventActionNames["CLOSE_TRANSACTION_DETAILS_MODAL"] = "close_transaction_details_modal";
    SegmentEventActionNames["CLICK_RESEND_LINK_BUTTON"] = "click_resend_link_button";
    SegmentEventActionNames["ENTER_VIN_NUMBER"] = "enter_vin_number";
    SegmentEventActionNames["CLICK_VALIDATE_VIN_NUMBER_BUTTON"] = "click_validate_vin_number_button";
    SegmentEventActionNames["CLICK_BIN_NUMBER"] = "click_bin_number";
    SegmentEventActionNames["CLICK_CONTINUE_VEHICLE_DETAILS"] = "click_continue_vehicle_details";
    SegmentEventActionNames["CLICK_CONTINUE_CUSTOMER_DETAILS"] = "click_continue_customer_details";
    SegmentEventActionNames["ENTER_NAME"] = "enter_name";
    SegmentEventActionNames["ENTER_VALUE"] = "enter_value";
    SegmentEventActionNames["ENTER_MOBILE_NUMBER"] = "enter_mobile_number";
    SegmentEventActionNames["ENTER_EMAIL"] = "enter_email";
    SegmentEventActionNames["ENTER_ADDRESS"] = "enter_address";
    SegmentEventActionNames["ENTER_PINCODE"] = "enter_pincode";
    SegmentEventActionNames["CLICK_BACK_BUTTON"] = "click_back_button";
    SegmentEventActionNames["CLICK_EDIT_MODEL"] = "click_edit_model";
    SegmentEventActionNames["ISSUE_POLICY"] = "issue_policy";
    SegmentEventActionNames["SEND_LINK_TO_CUSTOMER"] = "send_link_to_customer";
    SegmentEventActionNames["CLICK_GO_HOME_BUTTON"] = "click_go_home_button";
    SegmentEventActionNames["SUBMIT_MODAL"] = "submit_modal";
    SegmentEventActionNames["CLICK_CANCEL_MODAL"] = "click_cancel_modal";
    SegmentEventActionNames["CLICK_DETAILS"] = "click_details";
    SegmentEventActionNames["SUBMIT_DETAILS"] = "submit_details";
})(SegmentEventActionNames || (SegmentEventActionNames = {}));
var SegmentEventFieldTypes;
(function(SegmentEventFieldTypes) {
    SegmentEventFieldTypes["DROPDOWN"] = "dropdown";
    SegmentEventFieldTypes["TEXT"] = "text";
    SegmentEventFieldTypes["RADIO"] = "radio";
    SegmentEventFieldTypes["CHECKBOX"] = "checkbox";
    SegmentEventFieldTypes["DATE"] = "date";
})(SegmentEventFieldTypes || (SegmentEventFieldTypes = {}));
var SegmentEventPageTypes;
(function(SegmentEventPageTypes) {
    SegmentEventPageTypes["MAIN_PAGE"] = "main_page";
    SegmentEventPageTypes["VEHICLE_VALIDATION_PAGE"] = "vehicle_validation_page";
    SegmentEventPageTypes["POPUP"] = "popup";
    SegmentEventPageTypes["OVERLAY"] = "overlay";
    SegmentEventPageTypes["NEW_PAGE"] = "new_page";
    SegmentEventPageTypes["REDIRECT"] = "redirect";
    SegmentEventPageTypes["DOWNLOAD"] = "download";
    SegmentEventPageTypes["NAVIGATION"] = "navigation";
    SegmentEventPageTypes["OTHER"] = "other";
    SegmentEventPageTypes["VEHICLE_DETAILS_PAGE"] = "vehicle_details_page";
    SegmentEventPageTypes["CUSTOMER_DETAILS_PAGE"] = "customer_details_page";
    SegmentEventPageTypes["REVIEW_DETAILS_PAGE"] = "review_details_page";
    SegmentEventPageTypes["SEND_LINK_TO_CUSTOMER_PAGE"] = "send_link_to_customer_page";
    SegmentEventPageTypes["CONGRATULATIONS_PAGE"] = "congratulations_page";
    SegmentEventPageTypes["DEALER_DETAILS_PAGE"] = "dealer_details_page";
    SegmentEventPageTypes["FORM_PAGE"] = "form_page";
})(SegmentEventPageTypes || (SegmentEventPageTypes = {}));


/***/ }),

/***/ 2199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var utils_segment_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7316);
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4262);
/* harmony import */ var _acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1187);
// constanst


// helpers


var sendSegmentEvent = function(eventNameType, eventData, additionalData) {
    var ref;
    var userDetails = additionalData.userDetails, isMobile = additionalData.isMobile;
    var product = (0,utils_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getProduct */ .w)(userDetails === null || userDetails === void 0 ? void 0 : userDetails.partner_id);
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        product: product,
        sub_product_name: utils_segment_constants__WEBPACK_IMPORTED_MODULE_0__/* .SUB_PRODUCT_NAME */ .tM,
        email: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.email : undefined,
        phone: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.phone : undefined,
        name: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.name) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.name : undefined,
        partner: !!(userDetails === null || userDetails === void 0 ? void 0 : userDetails.partner_id) ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.partner_id : undefined,
        page_url: window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href,
        referrer: document === null || document === void 0 ? void 0 : document.referrer,
        platform: isMobile ? "mweb" : "web",
        device: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent
    }, eventData);
    if (eventNameType === utils_segment_constants__WEBPACK_IMPORTED_MODULE_0__/* .SegmentEventNameTypes.VIEW */ .Pg.VIEW) (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1__.waitForAnalyticsLoad)().then(function() {
        return (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1__.pageEvent)(eventNameType, props);
    });
    if (eventNameType === utils_segment_constants__WEBPACK_IMPORTED_MODULE_0__/* .SegmentEventNameTypes.ACTION */ .Pg.ACTION || eventNameType === utils_segment_constants__WEBPACK_IMPORTED_MODULE_0__/* .SegmentEventNameTypes.EXCEPTION */ .Pg.EXCEPTION) (0,_acko_tech_building_blocks_ui_acko_analytics__WEBPACK_IMPORTED_MODULE_1__.trackEvent)(eventNameType, props);
};
/* harmony default export */ __webpack_exports__["Z"] = (sendSegmentEvent);


/***/ }),

/***/ 4733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IY": function() { return /* binding */ getDomainOrigin; },
/* harmony export */   "a8": function() { return /* binding */ isLocalhost; },
/* harmony export */   "uZ": function() { return /* binding */ getAxiosConfig; },
/* harmony export */   "wU": function() { return /* binding */ getHeaders; }
/* harmony export */ });
/* unused harmony export getServerHostDomain */
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1955);
/* provided dependency */ var process = __webpack_require__(3454);

var isLocalhost = function() {
    try {
        return  true && window.location.hostname === "localhost";
    } catch (e) {
        return false;
    }
};
var getDomainOrigin = function() {
    try {
        if (window !== undefined) {
            if (window.location.hostname === "localhost") {
                return "http://localhost:7000";
            }
            return window.location.origin;
        }
        return "https://www.acko.com";
    } catch (e) {
        console.error("domain error ", e);
        return "https://www.acko.com";
    }
};
var getServerHostDomain = function(host) {
    try {
        if (host === null || host === void 0 ? void 0 : host.includes("localhost")) {
            return "http://localhost:7000";
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === "tronix") {
            return "https://tronix.acko.com";
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === "master") {
            return "https://www.ackodev.com";
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === "isnp") {
            return "https://acko-isnp.ackodev.com";
        }
        return "https://www.acko.com";
    } catch (e) {
        return "https://www.acko.com";
    }
};
function getHeaders() {
    return {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "x-a-k": js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("x-a-k"),
        "x-a-t": js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("x-a-t"),
        "x-r-t": js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("x-r-t")
    };
}
// Returns axios config for local proxy support (withCredentials for localhost)
function getAxiosConfig() {
    return {
        headers: getHeaders(),
        withCredentials: isLocalhost()
    };
}


/***/ }),

/***/ 7631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C7": function() { return /* binding */ ModalLoader; },
/* harmony export */   "wY": function() { return /* binding */ PageLoader; },
/* harmony export */   "wr": function() { return /* binding */ GlobalStyle; }
/* harmony export */ });
/* unused harmony exports Img, CenterDiv, CheckboxWrapper, CheckboxText, ButtonLoaderImage, ErrorMessage */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    body {\n        overflow-x: hidden !important;\n    }\n    scroll-behavior: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    justify-content: center;\n    ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-direction: row;\n    margin-top: 10px;\n    align-items: center;\n    margin-top: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-weight: 500;\n    font-size: 12px;\n    color: #434f5a;\n    margin-left: 10px;\n    margin-top: 2px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    transform: -webkit-translate(-50%, -50%);\n    transform: -moz-translate(-50%, -50%);\n    transform: -ms-translate(-50%, -50%);\n    color: darkred;\n    width: 100px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: darkred;\n    width: 100px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: ",
        ";\n    width: 65px;\n    position: absolute;\n    left: 50%;\n    margin-top: ",
        ";\n    transform: translate(-50%, -50%);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 10px 0;\n    font-size: 12px;\n    color: ",
        ";\n    text-align: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var GlobalStyle = (0,_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(_templateObject());
var Img = (0,_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled)((next_image__WEBPACK_IMPORTED_MODULE_2___default()))(_templateObject1(), function(props) {
    return props.width;
}, function(props) {
    return props.height;
});
var CenterDiv = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject2(), function(props) {
    return props && props.styles;
});
var CheckboxWrapper = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3());
var CheckboxText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());
var PageLoader = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject5());
var ModalLoader = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject6());
var ButtonLoaderImage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject7(), function(props) {
    return props.visibility ? "block" : "none";
}, function(props) {
    return props.marginTop || "30px";
});
var ErrorMessage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject8(), _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.$error);


/***/ }),

/***/ 7834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ confirmation; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/confirmation/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 16px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 24px;\n    color: #040222;\n    text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    text-align: center;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n    color: #040222;\n    margin-top: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    margin-top: 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    margin: 0 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var ImageFlex = building_blocks_ui_common_dist.styled.div(_templateObject1());
var Text = building_blocks_ui_common_dist.styled.div(_templateObject2());
var SubText = building_blocks_ui_common_dist.styled.div(_templateObject3());
var ButtonsRow = building_blocks_ui_common_dist.styled.div(_templateObject4());
var ButtonWrapper = building_blocks_ui_common_dist.styled.div(_templateObject5());

;// CONCATENATED MODULE: ./widgets/confirmation/index.tsx





function Confirmation(param) {
    var image = param.image, text = param.text, subText = param.subText, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageFlex, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    width: "80px",
                    height: "80px",
                    alt: "",
                    src: (0,generics/* getImageBasePath */.m4)(image)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Text, {
                children: text
            }),
            subText && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubText, {
                children: subText
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ButtonsRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.SecondaryButton, {
                            onClick: function(e) {
                                return onClick(e, "no");
                            },
                            children: "No"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.PrimaryButton, {
                            onClick: function(e) {
                                return onClick(e, "yes");
                            },
                            children: "Yes"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var confirmation = (Confirmation);


/***/ }),

/***/ 8269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ errorScreen; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./widgets/header/index.tsx + 1 modules
var header = __webpack_require__(9015);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/styles/index.ts
var styles = __webpack_require__(7631);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.button/dist/index.js
var dist = __webpack_require__(2518);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./hooks/useFetchParams.ts
var useFetchParams = __webpack_require__(6982);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/errorScreen/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    padding: 20px;\n    height: 100vh;\n    max-width: 400px;\n    margin: 0 auto;\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),\n        #ffffff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 270px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    color: #414a53;\n    margin-bottom: 20px;\n    white-space: pre-wrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var RootWrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var Container = building_blocks_ui_common_dist.styled.div(_templateObject1());
var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject2());
var ErrorMessage = building_blocks_ui_common_dist.styled.div(_templateObject3());
var ButtonWrapper = building_blocks_ui_common_dist.styled.div(_templateObject4());

// EXTERNAL MODULE: ./components/newPlan/plans/header/index.tsx + 1 modules
var plans_header = __webpack_require__(9994);
;// CONCATENATED MODULE: ./widgets/errorScreen/index.tsx












function ErrorPage(param) {
    var errorCode = param.errorCode, errorMessage = param.errorMessage, hideHeader = param.hideHeader, showEditDeviceHeader = param.showEditDeviceHeader;
    var router = (0,next_router.useRouter)();
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var partnerId = (0,compat_module.useContext)(context/* MPosContext */.w).partnerId;
    var goToDashboard = function() {
        router.push("/".concat(lob, "/").concat(partnerId || "oppo", "/dashboard"));
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RootWrapper, {
        children: [
            !hideHeader && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header/* default */.Z, {}),
            showEditDeviceHeader && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(plans_header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* GlobalStyle */.wr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            style: {
                                margin: "30px 0",
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)("/images/oopsError.svg"),
                                width: "140px",
                                height: "140px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ErrorMessage, {
                            children: errorMessage || "Oops... Something went wrong."
                        }),
                        errorCode === 404 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.PrimaryButton, {
                                onClick: goToDashboard,
                                children: "Go to dashboard"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var errorScreen = (ErrorPage);


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/context/index.ts
var context = __webpack_require__(7720);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/localStorage/partnerStorage.js
var partnerStorage = __webpack_require__(1246);
// EXTERNAL MODULE: ./hooks/useFetchParams.ts
var useFetchParams = __webpack_require__(6982);
// EXTERNAL MODULE: ./utils/responsive/index.tsx
var responsive = __webpack_require__(1798);
// EXTERNAL MODULE: ./components/newPlan/constants.ts
var constants = __webpack_require__(5327);
// EXTERNAL MODULE: ./utils/segment/constants.ts
var segment_constants = __webpack_require__(7316);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.acko-analytics/dist/index.js
var dist = __webpack_require__(4262);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var building_blocks_ui_common_dist = __webpack_require__(9749);
;// CONCATENATED MODULE: ./widgets/header/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding-bottom: 20px;\n    max-width: 400px;\n    margin: 0 auto;\n\n    @media screen and (max-width: 769px) {\n        max-width: 700px;\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    flex: 0 0 auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    gap: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid #000000;\n    background: #ffffff;\n    color: #000000;\n    border-radius: 12px;\n    padding: 8px 14px;\n    cursor: pointer;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    line-height: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    min-width: 180px;\n    background: #ffffff;\n    border: 1px solid #d7d7de;\n    border-radius: 12px;\n    box-shadow: 0 8px 20px rgba(16, 18, 35, 0.12);\n    padding: 6px;\n    z-index: 20;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    align-items: center;\n    border: 0;\n    border-radius: 8px;\n    background: ",
        ";\n    color: #101223;\n    padding: 10px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: ",
        ";\n\n    &:hover {\n        background: #f3f5f7;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var Wrapper = building_blocks_ui_common_dist.styled.div(_templateObject());
var LogosWrapper = building_blocks_ui_common_dist.styled.div(_templateObject1());
var AckoLogoWrapper = building_blocks_ui_common_dist.styled.div(_templateObject2());
var PartnerLogoWrapper = building_blocks_ui_common_dist.styled.div(_templateObject3());
var HamburgerWrapper = building_blocks_ui_common_dist.styled.div(_templateObject4());
var RightControls = building_blocks_ui_common_dist.styled.div(_templateObject5());
var GroupSwitchWrapper = building_blocks_ui_common_dist.styled.div(_templateObject6());
var GroupSwitchButton = building_blocks_ui_common_dist.styled.button(_templateObject7());
var GroupSwitchIcon = building_blocks_ui_common_dist.styled.span(_templateObject8());
var GroupSwitchText = building_blocks_ui_common_dist.styled.span(_templateObject9());
var GroupDropdown = building_blocks_ui_common_dist.styled.div(_templateObject10());
var GroupDropdownItem = building_blocks_ui_common_dist.styled.button(_templateObject11(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#f3f5f7" : "#ffffff";
}, function(param) {
    var isActive = param.isActive;
    return isActive ? 700 : 500;
});

// EXTERNAL MODULE: ./utils/constants/index.ts
var utils_constants = __webpack_require__(1485);
;// CONCATENATED MODULE: ./widgets/header/index.tsx
/* eslint-disable @next/next/no-img-element */ 













function Header(param) {
    var _wrapperStyles = param.wrapperStyles, wrapperStyles = _wrapperStyles === void 0 ? {} : _wrapperStyles;
    var ref;
    var lob = (0,useFetchParams/* useFetchParams */.u)().lob;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,compat_module.useContext)(context/* MPosContext */.w), partnerId = ref1.partnerId, permissions = ref1.permissions, showHamburger = ref1.showHamburger, setShowHamburger = ref1.setShowHamburger, setActiveStage = ref1.setActiveStage, setPlanDetails = ref1.setPlanDetails, userAccessList = ref1.userAccessList;
    var isLoginPage = router.pathname.includes("login");
    var isLegalDocumentsPage = router.asPath.includes("/legal-documents");
    var isDealerDetailsPage = router.asPath.includes("/dealer-details");
    var isGstDetailsPage = router.asPath.includes("/gst-details");
    var isDetailsPage = router.asPath.endsWith("/details");
    var hideGroupSwitchOnPage = router.pathname === "/partners" || router.pathname === "/partners/access";
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    var ref2 = (0,compat_module.useState)(false), showGroupDropdown = ref2[0], setShowGroupDropdown = ref2[1];
    var getPartnerLogo = function() {
        try {
            var partner_logo = permissions.partner_logo;
            if (partner_logo) {
                return partner_logo;
            }
            switch(partnerId){
                case "oppo":
                    return "/logos/oppo.png";
                case "ather":
                    return "/logos/ather.svg";
                default:
                    return "";
            }
        } catch (e) {
            return "";
        }
    };
    var disableLogoNavigation = isLoginPage || isLegalDocumentsPage || isDealerDetailsPage || isGstDetailsPage || isDetailsPage;
    var logoOnClick = function() {
        if (!disableLogoNavigation) {
            setShowHamburger(false);
            setActiveStage(constants/* NewPlanStages.MODEL */.W6.MODEL);
            setPlanDetails(constants/* policyDetailsInitState */.c8);
            if (permissions.permission_list.includes("access_only_auto_commercial_flow")) {
                router.push("/".concat(lob, "/").concat(partnerId, "/form"));
                return;
            }
            router.push("/".concat(lob, "/").concat(partnerId, "/dashboard"));
        }
    };
    var onClickMenu = function() {
        var ref;
        setShowHamburger(function(s) {
            return !s;
        });
        /**
         * segment event
         */ (0,dist.trackEvent)(segment_constants/* SegmentEventNameTypes.ACTION */.Pg.ACTION, {
            page_url: (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href) || "",
            action_type: segment_constants/* SegmentEventActionTypes.TAP_BTN */.Qy.TAP_BTN,
            button_name: segment_constants/* SegmentEventButtonNames.MENU */.A3.MENU,
            product: segment_constants/* PRODUCT */.c5,
            sub_product: segment_constants/* SUB_PRODUCT_NAME */.tM,
            platform: isMobile ? "mweb" : "web",
            device: navigator.userAgent || "",
            partner: partnerId,
            action_name: segment_constants/* SegmentEventActionNames.CLICK_MENU */.iV.CLICK_MENU
        });
    };
    var partnerLogo = getPartnerLogo();
    var selectedPartnerContext = (0,partnerStorage/* getPartnerContext */.gu)();
    var currentPartnerId = (selectedPartnerContext === null || selectedPartnerContext === void 0 ? void 0 : selectedPartnerContext.partner_id) || (permissions === null || permissions === void 0 ? void 0 : permissions.partner_id) || partnerId;
    var currentPartnerAccess = userAccessList === null || userAccessList === void 0 ? void 0 : userAccessList.find(function(access) {
        return ((access === null || access === void 0 ? void 0 : access.partner_id) || "").toLowerCase() === (currentPartnerId || "").toLowerCase();
    });
    var groups = (currentPartnerAccess === null || currentPartnerAccess === void 0 ? void 0 : currentPartnerAccess.groups) || [];
    var hasMultipleGroups = groups.length > 1;
    var selectedGroupName = selectedPartnerContext === null || selectedPartnerContext === void 0 ? void 0 : (ref = selectedPartnerContext.group) === null || ref === void 0 ? void 0 : ref.group_name;
    var selectedGroup = groups.find(function(group) {
        return group.group_name === selectedGroupName;
    }) || groups[0];
    var switchLabel = (selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.store_type) || "Switch";
    var onClickSwitchGroup = function() {
        setShowGroupDropdown(function(state) {
            return !state;
        });
    };
    var onSelectGroup = function(group) {
        if (!currentPartnerId) return;
        (0,partnerStorage/* savePartnerContext */.po)(currentPartnerId, group);
        setShowGroupDropdown(false);
        setShowHamburger(false);
        router.reload();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
        style: wrapperStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LogosWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AckoLogoWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: utils_constants/* AckoLogoConfig.gradient */.G4.gradient,
                            width: "82px",
                            height: "26px",
                            onClick: logoOnClick
                        })
                    }),
                    !hideGroupSwitchOnPage && partnerLogo && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PartnerLogoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                style: {
                                    borderLeft: "1px solid #E7E7F0",
                                    marginRight: "8px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                style: {
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    src: partnerLogo,
                                    width: "70px",
                                    height: "22px",
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            }),
            !isLoginPage && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(RightControls, {
                children: [
                    !showHamburger && !hideGroupSwitchOnPage && hasMultipleGroups && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GroupSwitchWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(GroupSwitchButton, {
                                type: "button",
                                onClick: onClickSwitchGroup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupSwitchIcon, {
                                        children: "⇆"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupSwitchText, {
                                        children: switchLabel
                                    })
                                ]
                            }),
                            showGroupDropdown && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupDropdown, {
                                children: groups.map(function(group) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(GroupDropdownItem, {
                                        type: "button",
                                        isActive: group.group_name === selectedGroupName,
                                        onClick: function() {
                                            return onSelectGroup(group);
                                        },
                                        children: group.store_type
                                    }, group.group_name);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HamburgerWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            style: {
                                cursor: "pointer"
                            },
                            src: (0,generics/* getImageBasePath */.m4)(showHamburger ? "/icons/close.svg" : "/icons/hamburger.svg"),
                            width: "24px",
                            height: "24px",
                            onClick: onClickMenu
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var header = (Header);


/***/ }),

/***/ 906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 5675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8045)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 9921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 9864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(9921);
} else {}


/***/ }),

/***/ 63:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerStyleSheet": function() { return /* binding */ ServerStyleSheet; },
  "StyleSheetConsumer": function() { return /* binding */ StyleSheetConsumer; },
  "StyleSheetContext": function() { return /* binding */ StyleSheetContext; },
  "StyleSheetManager": function() { return /* binding */ StyleSheetManager; },
  "ThemeConsumer": function() { return /* binding */ ThemeConsumer; },
  "ThemeContext": function() { return /* binding */ ThemeContext; },
  "ThemeProvider": function() { return /* binding */ ThemeProvider; },
  "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS": function() { return /* binding */ __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; },
  "createGlobalStyle": function() { return /* binding */ createGlobalStyle; },
  "css": function() { return /* binding */ css; },
  "default": function() { return /* binding */ styled_components_browser_esm; },
  "isStyledComponent": function() { return /* binding */ isStyledComponent; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withTheme": function() { return /* binding */ withTheme; }
});

// EXTERNAL MODULE: ./node_modules/stylis/stylis.min.js
var stylis_min = __webpack_require__(1746);
var stylis_min_default = /*#__PURE__*/__webpack_require__.n(stylis_min);
// EXTERNAL MODULE: ./node_modules/stylis-rule-sheet/index.js
var stylis_rule_sheet = __webpack_require__(1427);
var stylis_rule_sheet_default = /*#__PURE__*/__webpack_require__.n(stylis_rule_sheet);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(9864);
;// CONCATENATED MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ var memoize_one_esm = (memoizeOne);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

;// CONCATENATED MODULE: ./node_modules/is-what/dist/index.esm.js
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */
function isFunction(payload) {
    return typeof payload === 'function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */
function index_esm_isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */
function isFullArray(payload) {
    return index_esm_isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */
function isEmptyArray(payload) {
    return index_esm_isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */
function isMap(payload) {
    return getType(payload) === 'Map';
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */
function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */
function isSet(payload) {
    return getType(payload) === 'Set';
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */
function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */
function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function (value) {
        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}



;// CONCATENATED MODULE: ./node_modules/merge-anything/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!isPlainObject(newComer)) {
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (isPlainObject(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (isPlainObject(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && isPlainObject(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (isArray(originVal) && isArray(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ var index_esm = (merge);


;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(3454);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var styled_components_browser_esm_isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function styled_components_browser_esm_isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? 0 : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else { var _this; }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = stylis_rule_sheet_default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : 0;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return compat_module["default"].createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return (0,compat_module.cloneElement)(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in unitless_browser_esm)) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (styled_components_browser_esm_isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (styled_components_browser_esm_isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (styled_components_browser_esm_isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {}

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return styled_components_browser_esm_isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (styled_components_browser_esm_isFunction(styles) || styled_components_browser_esm_isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!(0,react_is.isValidElementType)(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (styled_components_browser_esm_isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (styled_components_browser_esm_isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return styled_components_browser_esm_isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic =  true && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function styled_components_browser_esm_escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? 0 : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[react_is.ForwardRef] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = (0,compat_module.createContext)();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return compat_module["default"].createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return compat_module["default"].createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (styled_components_browser_esm_isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {}

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(compat_module.Component);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return compat_module["default"].createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = (0,compat_module.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = memoize_one_esm(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return compat_module["default"].createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? 0 : children
    );
  };

  return StyleSheetManager;
}(compat_module.Component);
 false ? 0 : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : styled_components_browser_esm_escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {}
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return compat_module["default"].createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return compat_module["default"].createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {}

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || is_prop_valid_browser_esm(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return (0,compat_module.createElement)(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (styled_components_browser_esm_isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (styled_components_browser_esm_isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {}

            attr = attr(context);

            if (false) {}
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) {}

    return className;
  };

  return StyledComponent;
}(compat_module.Component);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? styled_components_browser_esm_escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return compat_module["default"].createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = compat_module["default"].forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : styled_components_browser_esm_escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? index_esm(target.defaultProps, obj) : obj;
    }
  });

  if (false) {}

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {}

      return compat_module["default"].createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return compat_module["default"].createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(compat_module["default"].Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {}

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = compat_module["default"].forwardRef(function (props, ref) {
    return compat_module["default"].createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {}

        return compat_module["default"].createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {}

/* Warning if there are several instances of styled-components */
if (false) {}

//

/* harmony default export */ var styled_components_browser_esm = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 1427:
/***/ (function(module) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		0
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ 1746:
/***/ (function(module) {

!function(e){ true?module.exports=e(null):0}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 1955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 7997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HY": function() { return /* reexport */ preact_module/* Fragment */.HY; },
  "tZ": function() { return /* reexport */ e; },
  "BX": function() { return /* reexport */ e; }
});

// UNUSED EXPORTS: jsxDEV

// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module = __webpack_require__(6400);
;// CONCATENATED MODULE: ./node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
var o=0;function e(_,e,n,t,f){var l,s,u={};for(s in e)"ref"==s?l=e[s]:u[s]=e[s];var a={type:_,props:u,key:n,ref:l,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:--o,__source:f,__self:t};if("function"==typeof _&&(l=_.defaultProps))for(s in l)void 0===u[s]&&(u[s]=l[s]);return preact_module/* options.vnode */.YM.vnode&&preact_module/* options.vnode */.YM.vnode(a),a}
//# sourceMappingURL=jsxRuntime.module.js.map

;// CONCATENATED MODULE: ./node_modules/preact/compat/jsx-runtime.mjs





/***/ }),

/***/ 8593:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [179], function() { return __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);